import moment from 'moment';
import { orderBy } from 'natural-orderby';
import React, { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { NavLink, withRouter } from 'react-router-dom';

import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';
import { Card, CardBody, CardHeader, Col, Form, Row } from 'react-bootstrap';
import docImg from '../../../../../assets/icons/document.png';
import BadgeStatus from '../../../../../common/BadgeStatus';
import Modal from '../../../../../components/Modal';
import AlertService from '../../../../../components/SweetAlert';
import ToastUtil from '../../../../../components/ToastNotification/ToastUtil';
import { config } from '../../../../../config/index';
import { DELETE, GET, newFetch, POST, PUT } from '../../../../../helpers/fetch';
import { to12Hr, toWeekDaysArrayFull } from '../../../../../helpers/moment';
import LayoutContext from '../../../../../store/Layout/contexts';

import SpringLoader from '../../../../../components/SpringLoader/SpringLoader.js';
const { API_URL, SERVER_URL } = config;

const filterApproversBySites = (users, siteIds) => {
  const selectedSiteIds = new Set(siteIds.filter(Boolean).map(Number));

  return users.filter((user) => {
    const isSiteRestricted =
      user.type === 'client' || Number(user.is_ops) === 1;

    if (!isSiteRestricted) return true;

    return user.client_admins?.some((adminClient) =>
      adminClient.sites?.some((site) =>
        selectedSiteIds.has(Number(site.site_id)),
      ),
    );
  });
};

const EditAssociate = ({ history, match: { params } }) => {
  const token = localStorage.getItem('token');
  const associate_id = parseInt(params.associate_id);
  const [clientSettings, setClientSettings] = useState([]);
  const [clients, setClients] = useState([]);
  const [clientUsers, setClientUsers] = useState([]);
  const [admins, setAdmins] = useState([]);
  const [adminsList, setAdminsList] = useState([]);
  const [activeClient, setActiveClient] = useState(null);
  const [assocClient, setAssocClient] = useState(null);
  const [showOldSites, setShowOldSites] = useState(true);
  const [sites, setSites] = useState([]);
  const [activeSites, setActiveSites] = useState([]);
  const [shifts, setShifts] = useState([]);
  const [activeShifts, setActiveShifts] = useState([]);
  const [siteAssociateArr, setSiteAssociateArr] = useState([]);
  const [associate, setAssociate] = useState({});
  const [isResendingInvites, setIsResendingInvites] = useState(false);
  const [associateList, setAssociateList] = useState({});
  const [associateSite, setAssociateSite] = useState({});
  const [scheduleList, setScheduleList] = useState({});
  const [bhCandID, setBHCandID] = useState('');
  // const [pbJOID, setPBJOID] = useState("");
  const [pbCandID, setPBCandID] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [employeeNo, setEmployeeNo] = useState('');
  const [employeeID, setEmployeeID] = useState('');
  const [dateOfBirth, setDateOfBirth] = useState('');
  const [email, setEmail] = useState('');
  const [data, setData] = React.useState([]);
  const [leaveList, setLeaveList] = useState([]);
  const [loadingLeave, setLoadingLeave] = useState(true);
  const [totalRows, setTotalRows] = useState(0);
  const [leaveSummaryId, setLeaveSummaryId] = useState();
  const [leaveTypes, setLeaveTypes] = useState([]);
  const [appliedLeaves, setAppliedLeaves] = useState([]);
  const [sortModel, setSortModel] = useState([
    { field: 'updatedAt', sort: 'desc' },
  ]);
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 10,
    page: 0,
  });
  const [positionList, setPositionList] = useState([]);
  const [multipleRoles, setMultipleRoles] = useState([
    {
      id: null,
      associate_schedules: [],
      associate_id: associate_id,
      pb_jo_no: '',
      role: '',
      is_disabled: false,
      is_deleted: false,
    },
  ]);

  const [position, setPosition] = useState('');
  const [teamList, setTeamList] = useState([]);
  const [team, setTeam] = useState('');
  const [department, setDepartment] = useState('');
  const [team_lead_id, setTeamLeadID] = useState('');
  const [departmentList, setDepartmentList] = useState([]);
  const [language, setLanguage] = useState('');
  const [isDisplayLastNameFirst, setIsDisplayLastNameFirst] = useState(false);
  const [password, setPassword] = useState('');
  const [claimApprovers, setClaimApprovers] = useState([]);
  const [leaveApprovers, setLeaveApprovers] = useState([]);
  const [claimCreditLimitPercentage, setClaimCreditLimitPercentage] = useState(
    [],
  );
  const [selectedApprovers, setSelectedApprovers] = useState({});
  const [selectedLeaveApprovers, setSelectedLeaveApprovers] = useState({});
  const [sitesToDelete, setSitesToDelete] = useState([]);
  const [restDays, setRestDays] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [validated, setValidated] = useState(false);

  const bhCandIDHandler = (e) => setBHCandID(e.target.value);
  //const pbCandIDHandler = (e) => setPBJOID(e.target.value);
  const firstNameHandler = (e) => setFirstName(e.target.value);
  const lastNameHandler = (e) => setLastName(e.target.value);
  const employeeNoHandler = (e) => setEmployeeNo(e.target.value);
  const employeeIDHandler = (e) => setEmployeeID(e.target.value);
  const DepartmentHandler = (e) => setDepartment(e.target.value);
  const dateOfBirthHandler = (e) => setDateOfBirth(e.target.value);
  const emailHandler = (e) => setEmail(e.target.value);
  const passwordHandler = (e) => setPassword(e.target.value);
  const positionHandler = (e, index) => {
    multipleRoles[index].role = e.target.value;
    setMultipleRoles([...multipleRoles]);
    setPosition(e.target.value);
  };
  const [selectedLeaveTypes, setSelectedLeaveTypes] = useState([]);
  const [modalMode, setModalMode] = useState('add');
  const [showLeaveSummaryModal, setShowLeaveSummaryModal] = useState(false);
  const [leaveTypeName, setLeaveTypeName] = useState([]);
  //Leave Summary Form
  const [leaveTypeId, setLeaveTypeId] = useState('');
  const [maxLeaves, setMaxLeaves] = useState('');
  const [available, setAvailable] = useState('');
  const [taken, setTaken] = useState(0); // Usually from DB
  const [activeDate, setActiveDate] = useState('');
  const [expiryDate, setExpiryDate] = useState('');
  const [showTaken, setShowTaken] = useState(false);

  const isEditMode = modalMode === 'edit';
  const api_path = isEditMode
    ? `/associate-leave-summary/${leaveSummaryId}` // Assuming you have leaveSummaryId for edit
    : `/associate-leave-summary`;

  const leaveColumns = [
    {
      field: 'leave_type.leave_name',
      headerName: 'Leave Type',
      flex: 2,
      sortable: true,
      disableColumnMenu: true,
      renderCell: (params) => (
        <span
          className="leave-link"
          onClick={() => handleLeaveTypeClick(params.row.leave_type_id)}
        >
          {params.row.leave_type?.leave_name || '--'}
        </span>
      ),
    },
    {
      field: 'max_leaves',
      headerName: 'Max Per Year',
      flex: 1,
      sortable: true,
      disableColumnMenu: true,
      renderCell: (params) => (
        <span style={{ color: '#212529', fontSize: 15, fontWeight: 400 }}>
          {params.row.max_leaves ?? '--'}
        </span>
      ),
    },
    {
      field: 'available',
      headerName: 'Available',
      flex: 1,
      sortable: true,
      disableColumnMenu: true,
      renderCell: (params) => (
        <span style={{ color: '#212529', fontSize: 15, fontWeight: 400 }}>
          {params.row.available ?? '--'}
        </span>
      ),
    },
    {
      field: 'taken',
      headerName: 'Taken',
      flex: 1,
      sortable: true,
      disableColumnMenu: true,
      renderCell: (params) => (
        <span style={{ color: '#212529', fontSize: 15, fontWeight: 400 }}>
          {params.row.taken ?? '--'}
        </span>
      ),
    },
    {
      field: 'pending',
      headerName: 'Pending for Approval',
      flex: 1,
      sortable: true,
      disableColumnMenu: true,
      renderCell: (params) => (
        <span style={{ color: '#212529', fontSize: 15, fontWeight: 400 }}>
          {params.row.pending ?? '--'}
        </span>
      ),
    },
    {
      field: 'active_date',
      headerName: 'Active From',
      flex: 1,
      sortable: true,
      disableColumnMenu: true,
      renderCell: (params) => (
        <span style={{ color: '#212529', fontSize: 15, fontWeight: 400 }}>
          {params.row.active_date
            ? moment(params.row.active_date, 'YYYY-MM-DD').format('DD/MM/YYYY')
            : '--'}
        </span>
      ),
    },
    {
      field: 'expiry_date',
      headerName: 'Active To',
      flex: 1,
      sortable: true,
      disableColumnMenu: true,
      renderCell: (params) => (
        <span style={{ color: '#212529', fontSize: 15, fontWeight: 400 }}>
          {params.row.expiry_date
            ? moment(params.row.expiry_date, 'YYYY-MM-DD').format('DD/MM/YYYY')
            : '--'}
        </span>
      ),
    },
  ];

  const leaveDetailColumns = [
    {
      field: 'id',
      headerName: 'Request ID',
      flex: 0.8,
      sortable: true,
    },
    {
      field: 'leave_type_name',
      headerName: 'Leave Type',
      flex: 1,
      sortable: true,
    },
    {
      field: 'status',
      headerName: 'Status',
      flex: 0.9,
      sortable: true,
      renderCell: (params) => {
        return <BadgeStatus status={params.row.status} />;
      },
    },

    // Leave From (use valueGetter for sorting, renderCell for display)
    {
      field: 'leave_from',
      headerName: 'Leave From',
      flex: 0.9,
      sortable: true,
      // valueGetter returns timestamp (number) so sorting works correctly
      valueGetter: (params) => {
        const raw = params.row?.leave_from;
        return raw ? new Date(raw).getTime() : null;
      },
      // renderCell shows formatted date (use the original row value)
      renderCell: (params) => {
        const raw = params.row?.leave_from;
        return raw ? moment(raw).format('DD/MM/YYYY') : '';
      },
    },

    // Leave To (same pattern)
    {
      field: 'leave_to',
      headerName: 'Leave To',
      flex: 0.9,
      sortable: true,
      valueGetter: (params) => {
        const raw = params.row?.leave_to;
        return raw ? new Date(raw).getTime() : null;
      },
      renderCell: (params) => {
        const raw = params.row?.leave_to;
        return raw ? moment(raw).format('DD/MM/YYYY') : '';
      },
    },

    // Day Type (leave_coverage)
    {
      field: 'leave_coverage',
      headerName: 'Day Type',
      flex: 0.9,
      sortable: true,
      // keep numeric code for sorting
      valueGetter: (params) => {
        // make sure to read the actual property in row
        const v = params.row?.leave_coverage;
        return v !== undefined && v !== null ? Number(v) : -1;
      },
      // display mapping
      renderCell: (params) => {
        const dayTypes = {
          0: 'Full Day',
          1: 'Half Day (AM)',
          2: 'Half Day (PM)',
        };
        const code = params.row?.leave_coverage;
        return dayTypes[code] ?? 'N/A';
      },
    },

    // Total Days
    {
      field: 'no_of_days',
      headerName: 'Total Days',
      flex: 0.8,
      sortable: true,
      renderCell: (params) => {
        const value =
          params.row?.no_of_days !== undefined &&
          params.row?.no_of_days !== null
            ? Number(params.row.no_of_days)
            : 0;

        return <span>{Number.isFinite(value) ? value.toFixed(1) : '0.0'}</span>;
      },
    },
    {
      field: 'documents',
      headerName: 'Docs',
      flex: 0.7,
      sortable: false,
      renderCell: (params) => {
        const docs = params.row?.documents || [];

        return (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
              height: '100%',
              gap: '8px',
            }}
          >
            {docs.map((doc, index) => (
              <a
                key={index}
                href={`${SERVER_URL}/storage/leaves/${doc.new_file}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <img
                  src={docImg}
                  alt="Document"
                  style={{ width: '24px', height: '24px' }}
                />
              </a>
            ))}
          </div>
        );
      },
    },
    // Remarks (wrap)
    {
      field: 'remarks',
      headerName: 'Remarks',
      flex: 1.5,
      sortable: false,
      renderCell: (params) => (
        <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
          {params.value ?? params.row?.remarks ?? '-'}
        </div>
      ),
    },
  ];

  const handleRestDayChange = (day, e) => {
    if (e.target.checked) {
      setRestDays([...restDays, day]);
    } else {
      setRestDays(restDays.filter((d) => d !== day));
    }
  };

  const fetchRestDays = async () => {
    try {
      const response = await newFetch(
        GET,
        `/associate/${associate_id}/rest-days`,
      );
      if (response.success) {
        setRestDays(response.data.map((item) => item.day));
      }
    } catch (error) {
      console.log('Error fetching rest days:', error);
    }
  };

  const fetchAppliedLeaves = async () => {
    try {
      let api_path = `/associate-leaves/${associate_id}`;
      let response = await newFetch(GET, api_path);

      if (response.success && response.success) {
        let leaves = response.data;
        setAppliedLeaves(leaves);
      } else {
        if (response.success) {
          ToastUtil.success(response.message);
        } else {
          ToastUtil.error(response.message);
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleLeaveTypeClick = (leaveTypeId) => {
    setModalMode('edit');
    fetchLeaveDetails(leaveTypeId);
    setShowLeaveSummaryModal(true);
  };

  const handleCloseLeaveSummaryModal = () => {
    setShowLeaveSummaryModal(false);
  };

  const formatDateForInput = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toISOString().split('T')[0]; // Returns YYYY-MM-DD format
  };

  const fetchLeaveTypesByAssociate = async () => {
    const api_path = `/leavetypes/option`;

    const response = await newFetch(POST, api_path, {
      associate_id: associate_id,
    });

    if (response.success) {
      setLeaveTypes(response.data); // assumes setLeaveTypes is your state setter
    } else {
      console.error('Failed to fetch leave types:', response.message);
    }
  };

  const handleLeaveSubmit = (e) => {
    e.preventDefault();
    saveLeaveSummary();
  };

  const saveLeaveSummary = async () => {
    // Validate required fields before sending
    if (!leaveTypeId || !activeDate || !expiryDate) {
      ToastUtil.error('Please fill in all required fields.');
      return;
    }

    // Validate date logic
    if (new Date(activeDate) > new Date(expiryDate)) {
      ToastUtil.error('Active From date must be before Active To date.');
      return;
    }

    // Validate numeric values
    if (maxLeaves < 0 || available < 0) {
      ToastUtil.error('Leave values cannot be negative.');
      return;
    }

    if (parseFloat(available) > parseFloat(maxLeaves)) {
      ToastUtil.error('Available leaves cannot exceed maximum leaves.');
      return;
    }

    // Determine API path and method based on mode
    const isEditMode = modalMode === 'edit';
    const api_path = isEditMode
      ? `/associate-leave-summary/${leaveSummaryId}` // Assuming you have leaveSummaryId for edit
      : `/associate-leave-summary`;
    const httpMethod = isEditMode ? 'PUT' : 'POST';

    // Payload based on your DB schema
    const payload = {
      associate_id: associate_id,
      leave_type_id: parseInt(leaveTypeId), // Ensure it's a number
      max_leaves: parseFloat(maxLeaves) || 0, // Handle empty strings
      available: parseFloat(available) || 0,
      taken: isEditMode ? parseFloat(taken) || 0 : 0, // Keep existing taken value in edit mode
      pending: 0,
      active_date: activeDate, // Format: 'YYYY-MM-DD'
      expiry_date: expiryDate, // Format: 'YYYY-MM-DD'
    };

    // For edit mode, you might want to include the ID in payload too (depends on your API)
    if (isEditMode && leaveSummaryId) {
      payload.id = leaveSummaryId;
    }

    try {
      const response = await newFetch(httpMethod, api_path, payload);

      if (response.success) {
        const successMessage = isEditMode
          ? 'Leave type updated successfully.'
          : 'Leave type added successfully.';

        ToastUtil.success(
          isEditMode ? 'Leave type updated.' : 'Leave type added.',
        );

        // Reset form fields only in add mode
        if (!isEditMode) {
          setLeaveTypeId('');
          setMaxLeaves('');
          setAvailable('');
          setActiveDate('');
          setExpiryDate('');
        }

        // Close modal and refresh data
        setShowLeaveSummaryModal(false);

        fetchLeave();
        // Refresh the leave summary data
        // fetchLeaveSummaryData(); // Uncomment if you have this function
      } else {
        const errorMessage = isEditMode
          ? 'Failed to update leave summary.'
          : 'Failed to add leave summary.';
        console.error(
          `${isEditMode ? 'Update' : 'Insert'} failed:`,
          response.message || 'Unknown error',
        );
        ToastUtil.error(response.message || errorMessage);
      }
    } catch (error) {
      const errorMessage = isEditMode
        ? 'An error occurred while updating leave summary. Please try again.'
        : 'An error occurred while adding leave summary. Please try again.';

      console.error(
        `Error while ${isEditMode ? 'updating' : 'inserting'} leave summary:`,
        error,
      );
      ToastUtil.error(errorMessage);
    }
  };

  const fetchLeaveDetails = async (leaveTypeId) => {
    const res = await newFetch(
      POST,
      `/leavetypes/${leaveTypeId}/associate_id/${associate_id}`,
    );

    if (res.success) {
      const data = res.data;

      // Set individual form fields
      setLeaveSummaryId(data.id || '');
      setLeaveTypeName(data.leave_type.name || '');
      setLeaveTypeId(data.leave_type_id || leaveTypeId);
      setMaxLeaves(data.max_leaves || '');
      setAvailable(data.available || '');
      setActiveDate(
        data.active_date ? formatDateForInput(data.active_date) : '',
      );
      setExpiryDate(
        data.expiry_date ? formatDateForInput(data.expiry_date) : '',
      );
      setTaken(data.taken ?? '0');

      // Keep the original data for reference if needed
      setSelectedLeaveTypes(data);
    } else {
      console.error('Failed to fetch leave type details:', res.message);
    }
  };

  const claimCreditLimitPercentageHandler = (event, type, siteId) => {
    const value = event.target.value;
    const parseValue = (val) => (val === '' ? '' : parseFloat(val));

    setClaimCreditLimitPercentage((prevState) => {
      const existing = prevState.find((item) => item.site === siteId);

      if (existing) {
        return prevState.map((item) =>
          item.site === siteId
            ? {
                ...item,
                creditLimit:
                  type === 'credit limit'
                    ? parseValue(value)
                    : item.creditLimit,
                creditPercentage:
                  type === 'credit percentage'
                    ? parseValue(value)
                    : item.creditPercentage,
                claimNoReceipts:
                  type === 'no of receipts'
                    ? parseValue(value)
                    : item.claimNoReceipts,
                safetyShoesCreditLimit:
                  type === 'safety shoes credit limit'
                    ? parseValue(value)
                    : item.safetyShoesCreditLimit,
              }
            : item,
        );
      } else {
        return [
          ...prevState,
          {
            site: siteId,
            creditLimit: type === 'credit limit' ? parseValue(value) : '',
            creditPercentage:
              type === 'credit percentage' ? parseValue(value) : '',
            claimNoReceipts: type === 'no of receipts' ? parseValue(value) : '',
            safetyShoesCreditLimit:
              type === 'safety shoes credit limit' ? parseValue(value) : '',
          },
        ];
      }
    });
  };

  const positionPBJONOHandler = (e, index) => {
    const value = e.target.value.replace(/\D/g, '');
    multipleRoles[index].pb_jo_no = value;
    setMultipleRoles([...multipleRoles]);
  };
  const TeamHandler = (e) => setTeam(e.target.value);
  const TeamLeadIDHandler = (e) => setTeamLeadID(e.target.value);
  const languageHandler = (e) => setLanguage(e.target.value);
  const displayLastNameHandler = (e) =>
    setIsDisplayLastNameFirst(e.target.checked);
  const [startDate, setStartDate] = useState(null);
  const [monthValue, setMonthValue] = useState();
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  const oldStartDateHandler = (index, e) => {
    let siteAssociatesArr = [...oldSiteAssociates];
    siteAssociatesArr[index].start_date = e.target.value;
    setOldSiteAssociates(siteAssociatesArr);
  };

  const oldResignDateHandler = (index, e) => {
    let siteAssociatesArr = [...oldSiteAssociates];
    siteAssociatesArr[index].resign_date = e.target.value;
    setOldSiteAssociates(siteAssociatesArr);
  };

  const oldLastDayDateHandler = (index, e) => {
    let siteAssociatesArr = [...oldSiteAssociates];
    siteAssociatesArr[index].last_day_date = e.target.value;
    setOldSiteAssociates(siteAssociatesArr);
  };

  const oldTeamSupportHandler = (index, e) => {
    const siteAssociatesArr = [...oldSiteAssociates];
    siteAssociatesArr[index].is_team_support = e.target.checked;
    setOldSiteAssociates(siteAssociatesArr);
  };

  const oldActiveHandler = (index, e) => {
    const siteAssociatesArr = [...oldSiteAssociates];
    siteAssociatesArr[index].active = e.target.checked;
    setOldSiteAssociates(siteAssociatesArr);
  };

  const oldRegrettableHandler = (index, e) => {
    const siteAssociatesArr = [...oldSiteAssociates];
    siteAssociatesArr[index].is_regrettable = e.target.checked;
    setOldSiteAssociates(siteAssociatesArr);
  };

  const oldBlueBadgeHandler = (index, e) => {
    const siteAssociatesArr = [...oldSiteAssociates];
    siteAssociatesArr[index].is_blue_badge = e.target.checked;
    setOldSiteAssociates(siteAssociatesArr);
  };

  const oldContractHandler = (index, e) => {
    const siteAssociatesArr = [...oldSiteAssociates];
    siteAssociatesArr[index].is_contract = e.target.checked;
    setOldSiteAssociates(siteAssociatesArr);
  };

  const newStartDateHandler = (index, e) => {
    let siteAssociatesArr = [...newSiteAssociates];
    siteAssociatesArr[index].start_date = e.target.value;
    setNewSiteAssociates(siteAssociatesArr);
  };

  const newResignDateHandler = (index, e) => {
    let siteAssociatesArr = [...newSiteAssociates];
    siteAssociatesArr[index].resign_date = e.target.value;
    setNewSiteAssociates(siteAssociatesArr);
  };

  const newLastDayDateHandler = (index, e) => {
    let siteAssociatesArr = [...newSiteAssociates];
    siteAssociatesArr[index].last_day_date = e.target.value;
    setNewSiteAssociates(siteAssociatesArr);
  };

  const newTeamSupportHandler = (index, e) => {
    const siteAssociatesArr = [...newSiteAssociates];
    siteAssociatesArr[index].is_team_support = e.target.checked;
    setNewSiteAssociates(siteAssociatesArr);
  };

  const newActiveHandler = (index, e) => {
    const siteAssociatesArr = [...newSiteAssociates];
    siteAssociatesArr[index].active = e.target.checked;
    setNewSiteAssociates(siteAssociatesArr);
  };

  const newRegrettableHandler = (index, e) => {
    const siteAssociatesArr = [...newSiteAssociates];
    siteAssociatesArr[index].is_regrettable = e.target.checked;
    setNewSiteAssociates(siteAssociatesArr);
  };

  const newBlueBadgeHandler = (index, e) => {
    const siteAssociatesArr = [...newSiteAssociates];
    siteAssociatesArr[index].is_blue_badge = e.target.checked;
    setNewSiteAssociates(siteAssociatesArr);
  };

  const newContractHandler = (index, e) => {
    const siteAssociatesArr = [...newSiteAssociates];
    siteAssociatesArr[index].is_contract = e.target.checked;
    setNewSiteAssociates(siteAssociatesArr);
  };

  const handleApproverChange = (siteApprovalId, sourceId) => {
    setSelectedApprovers((prev) => ({
      ...prev,
      [siteApprovalId]: {
        site_approval_id: siteApprovalId,
        source_id: sourceId,
      },
    }));
  };

  const handleLeaveApproverChange = (clientApprovalId, sourceId) => {
    setSelectedLeaveApprovers((prev) => ({
      ...prev,
      [clientApprovalId]: {
        client_approval_id: clientApprovalId,
        source_id: sourceId,
      },
    }));
  };

  const clientHandler = async (e) => {
    const newClientId = parseInt(e.target.value);

    // Validate client ID
    if (!newClientId || isNaN(newClientId)) {
      await AlertService.error(
        'Invalid Selection',
        'Please select a valid client.',
      );
      e.preventDefault();
      return;
    }

    // Find the selected client
    const selectedClient = clients.find((client) => client.id === newClientId);

    if (!selectedClient) {
      await AlertService.error(
        'Client Not Found',
        'The selected client does not exist.',
      );
      e.preventDefault();
      return;
    }

    // Check if client is actually changing (handle undefined/null assocClient)
    const isClientChanging = !assocClient || assocClient.id !== newClientId;

    // Only show confirmation if client is actually changing and there's data to lose
    const hasDataToLose =
      isClientChanging &&
      (newSiteAssociates.length > 0 ||
        newFixedSchedules.length > 0 ||
        oldSiteAssociates.length > 0);

    if (hasDataToLose) {
      const confirmed = await AlertService.confirm(
        'Change Client',
        "Assigning this Employee to a new Client will reset this Employee's assigned Sites and Fixed Schedules. Are you sure you want to proceed?",
      );

      if (!confirmed) {
        e.preventDefault();
        return;
      }
    }

    // Filter sites for the selected client
    const filteredSites = sites.filter(
      (site) => site.client_id === newClientId,
    );

    // Update state
    setActiveClient(selectedClient);
    setActiveSites(filteredSites);
    setNewSiteAssociates([]);

    if (isClientChanging) {
      // Reset to empty state when switching to a different client
      setOldSiteAssociates([]);
      setShowOldSites(false);
      setNewFixedSchedules([]);
    } else {
      // Restore original data when switching back to original client
      setNewFixedSchedules(oldFixedSchedules || []);
      setOldSiteAssociates(siteAssociates || []);
      setShowOldSites(true);
    }
  };

  const siteHandler = (e) => {
    const pickedSite = JSON.parse(e.target.value);
    if (
      !siteAssociates.some(
        (siteAssociate) => siteAssociate.site_id === parseInt(pickedSite.id),
      ) &&
      !newSiteAssociates.some(
        (site) => site.site_id === parseInt(pickedSite.id),
      )
    ) {
      addSiteAssociate(pickedSite.id, pickedSite.name);
      setActiveShifts(
        [...shifts].filter((shift) => shift.site_id === pickedSite.id),
      );
    }
  };

  const getSiteNameById = (id) => {
    const siteConst = sites.find((site) => site.id === id);
    if (siteConst) return siteConst.name;
  };

  const [siteAssociates, setSiteAssociates] = useState([]);
  const [oldSiteAssociates, setOldSiteAssociates] = useState([]);
  const [newSiteAssociates, setNewSiteAssociates] = useState([]);

  const [fixedSchedules, setFixedSchedules] = useState([]);
  const [oldFixedSchedules, setOldFixedSchedules] = useState([]);
  const [newFixedSchedules, setNewFixedSchedules] = useState([]);

  React.useEffect(() => {
    if (siteAssociates.length > 0) {
      for (let siteAssoc of siteAssociates) {
        setClaimCreditLimitPercentage((prevState) => {
          return [
            ...prevState,
            {
              site: siteAssoc.site_id,
              creditLimit: siteAssoc.claim_limit,
              creditPercentage: siteAssoc.claim_percentage,
              claimNoReceipts: siteAssoc.claim_no_receipt,
              safetyShoesCreditLimit: siteAssoc.ss_claim_limit,
            },
          ];
        });
      }
    }
  }, [siteAssociates]);

  const addSiteAssociate = (id, name) =>
    setNewSiteAssociates([
      ...newSiteAssociates,
      {
        site_id: id,
        is_team_support: false,
        start_date: null,
        resign_date: null,
        last_day_date: null,
        is_regrettable: false,
        is_blue_badge: false,
        is_contract: false,
        active: true,
      },
    ]);

  const addMoreRoles = () => {
    multipleRoles.push({
      id: null,
      associate_schedules: [],
      associate_id: associate_id,
      pb_jo_no: '',
      role: '',
      is_disabled: false,
      is_deleted: false,
    });
    setMultipleRoles([...multipleRoles]);
  };

  const removeRoles = (index) => {
    multipleRoles[index].is_deleted = true;
    setMultipleRoles([...multipleRoles]);
  };

  const removeOldSiteAssociate = async (e, index) => {
    if (
      await AlertService.confirm(
        '',
        "Are you sure you want to remove the site? The employee's scheduled/assigned shifts  linked to this site, will also be deleted.",
      )
    ) {
      setOldSiteAssociates(
        [...oldSiteAssociates].filter((siteAssociate, i) => i !== index),
      );
    } else {
      e.preventDefault();
    }
  };

  const removeSiteAssociate = (index) =>
    setNewSiteAssociates(
      [...newSiteAssociates].filter((siteAssociate, i) => i !== index),
    );

  const addFixedSchedule = (day, shift_id, site_id) =>
    setNewFixedSchedules([
      ...newFixedSchedules,
      {
        day,
        shift_id,
        site_id,
      },
    ]);

  const removeFixedSchedule = (day, shift_id, site_id) => {
    let filtered = [...newFixedSchedules].filter((site) => {
      return !(
        site.site_id === site_id &&
        site.day === day &&
        site.shift_id === shift_id
      );
    });
    setNewFixedSchedules(filtered);
  };

  const fixedScheduleCheckboxHandler = (day, shift_id, site_id, e) => {
    // check if is team support for site
    setSiteAssociateArr([...oldSiteAssociates, ...newSiteAssociates]);
    const site = [...oldSiteAssociates, ...newSiteAssociates].find(
      (site) => site.site_id === site_id,
    );
    if (e.target.checked) {
      if (site.is_team_support === true) {
        addFixedSchedule(day, shift_id, site_id);
      } else {
        e.preventDefault();
        e.stopPropagation();
        ToastUtil.error('Please set employee as team support for this site.');
      }
    } else {
      removeFixedSchedule(day, shift_id, site_id);
    }
  };

  const discardHandler = async () => {
    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to discard all changes?',
      )
    ) {
      setFirstName(associate.first_name);
      setLastName(associate.last_name);
      setEmployeeNo(associate.employee_no);
      setEmployeeID(associate.employee_id);
      setPBCandID(associate.pb_cand_id);
      //setPBJOID(associate.pb_jo_id);
      setBHCandID(associate.bh_cand_id);
      setDateOfBirth(associate.date_of_birth);
      setEmail(associate.email);
      setPassword('');
      setOldSiteAssociates(siteAssociates);
      setNewSiteAssociates([]);
      setPosition(associate.position);
      setTeam(associate.team);
      setIsDisplayLastNameFirst(associate.last_name_first ? true : false);
      // setOldFixedSchedules(fixedSchedules)
      setNewFixedSchedules(fixedSchedules);
    }
  };

  const fetchAssociate = async () => {
    let url = `${API_URL}/associate/${associate_id}`;

    try {
      let response = await fetch(url, {
        mode: 'cors',
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      let data = await response.json();

      if (response.ok) {
        const associateData = data.data;

        setAssociate(associateData);
        setFirstName(associateData.first_name);
        setLastName(associateData.last_name);
        setEmployeeNo(associateData.employee_no);
        setEmployeeID(associateData.employee_id);
        setPBCandID(associateData.pb_cand_id);
        //setPBJOID(associateData.pb_jo_id);
        setBHCandID(associateData.bh_cand_id);
        setDateOfBirth(associateData.date_of_birth);
        setEmail(associateData.email);
        setPassword('');
        setActiveClient(associateData.client);
        associateData.associate_roles.length > 0 &&
          setMultipleRoles(associateData.associate_roles);
        setAssociateSite(associateData.sites);
        setPosition(associateData.position);
        setTeam(associateData.team);
        setDepartment(associateData.department);
        setTeamLeadID(associateData.team_lead_id);
        setLanguage(associateData.language);
        setIsDisplayLastNameFirst(associateData.last_name_first ? true : false);
        setMonthValue(moment(associateData.date_of_birth).format('MMMM'));
        setStartDate(
          associateData.date_of_birth
            ? new Date(associateData.date_of_birth)
            : null,
        );
        setAssocClient(associateData.client);
      } else {
        ToastUtil.error('Failed to fetch employees!');
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchAssociateListBySiteID = async (site_id) => {
    let api_path = `/associate/site/${site_id}`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      let associatesData = response.data;
      let sorted = orderBy(associatesData, [
        (associate) => `${associate.first_name} ${associate.last_name}`,
      ]);
      setAssociateList(sorted);
    }
  };

  const fetchAssociateScheduleListByAssociateID = async (site_id) => {
    let api_path = `/associate/${associate_id}/schedule`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      let scheduleData = response.data;

      setScheduleList(scheduleData);
    }
  };

  async function fetchData() {
    try {
      const fetchPosition = await fetch(`${API_URL}/fields/position`, {
        method: 'GET',
        withCredentials: false,
        mode: 'cors',
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      });

      const fetchTeam = await fetch(`${API_URL}/fields/team`, {
        method: 'GET',
        withCredentials: false,
        mode: 'cors',
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      });

      const response = await Promise.all([fetchPosition, fetchTeam]);
      const data = await Promise.all(response.map((res) => res.json()));

      setPositionList(data[0].data);
      setTeamList(data[1].data);
    } catch (err) {
      console.log(err);
    }
  }

  const fetchClients = async () => {
    let url = `${API_URL}/client`;

    try {
      let response = await fetch(url, {
        mode: 'cors',
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      let data = await response.json();

      if (response.ok) {
        const clientsData = data.data;

        setClients(clientsData);
      } else {
        ToastUtil.error('Failed to fetch clients!');
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchAdmins = async () => {
    let api_path = `/admin/admins`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      let filtered = response.data.filter((admin) => admin.is_super != true);
      setAdminsList(filtered);
    }
  };

  const fetchClientUsers = async () => {
    if (!activeClient?.id) {
      console.error('Error: activeClient.id is missing or invalid.');
      return;
    }

    let url = `${API_URL}/client/users/client_users/${activeClient.id}`;

    try {
      let response = await fetch(url, {
        mode: 'cors',
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      let data = await response.json();

      if (response.ok) {
        setClientUsers(data.data);
      }
    } catch (error) {
      console.error('Error fetching client users:', error);
      ToastUtil.error('An error occurred while fetching client users.');
    }
  };

  const fetchAdminsByClient = async () => {
    if (!activeClient?.id) {
      console.error('Error: activeClient.id is missing or invalid.');
      return;
    }

    let url = `${API_URL}/admin/client/${activeClient.id}`;

    try {
      let response = await fetch(url, {
        mode: 'cors',
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      let data = await response.json();

      if (response.ok) {
        setAdmins(data.data);
      }
    } catch (error) {
      console.error('Error fetching admins:', error);
    }
  };

  const handleAddNewLeaveType = async (e) => {
    e.preventDefault();
    setLeaveTypeId('');
    setMaxLeaves('');
    setAvailable('');
    setActiveDate('');
    setExpiryDate('');
    setSelectedLeaveTypes(null);

    setModalMode('add');
    setShowLeaveSummaryModal(true);
  };

  const fetchSites = async () => {
    const url = `${API_URL}/sites`;
    try {
      let response = await fetch(url, {
        mode: 'cors',
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      let json = await response.json();

      if (response.ok) {
        setSites(json.data);
      } else {
        ToastUtil.error('Sites is not available');
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchShifts = async () => {
    const url = `${API_URL}/shifts`;
    try {
      let response = await fetch(url, {
        mode: 'cors',
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      let json = await response.json();

      if (response.ok) {
        const shifts = json.data.sort((a, b) => (a.name > b.name ? 1 : -1));
        setShifts(shifts);
      } else {
        ToastUtil.error('Shifts is not available');
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchSiteAssociates = async () => {
    const url = `${API_URL}/associate/${associate_id}/sites`;

    try {
      let response = await fetch(url, {
        mode: 'cors',
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      let json = await response.json();

      if (response.ok) {
        setSiteAssociates(json.data);
        setOldSiteAssociates(JSON.parse(JSON.stringify(json.data)));
      } else {
        ToastUtil.error('Site Employees is not available');
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchFixedSchedules = async () => {
    const url = `${API_URL}/associate/${associate_id}/fixed_schedule`;

    try {
      let response = await fetch(url, {
        mode: 'cors',
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      let json = await response.json();
      if (response.ok) {
        setFixedSchedules(json.data);
        setNewFixedSchedules(json.data);
        setOldFixedSchedules(json.data);
      } else {
        ToastUtil.error('Fixed schedule is not available');
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchDepartments = async (client_id) => {
    try {
      let api_path = `/lu_fields/type/department/client/${client_id}`;
      let response = await newFetch(GET, api_path);

      response.success
        ? setDepartmentList(response.data)
        : ToastUtil.error(response.message);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchClaimApprovers = async (site_id) => {
    if (!activeClient?.id || !token) {
      console.log('Client ID or token is missing');
      return [];
    }

    const url = `${API_URL}/client/${activeClient.id}/site/${site_id}/claimapprovers`;

    try {
      let response = await fetch(url, {
        mode: 'cors',
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization: token,
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      if (response.ok) {
        let data = await response.json();

        if (data.success) {
          return data.data.map((item) => ({
            name: item.site.name,
            id: item.id,
            value: item.type,
            site_id: item.site_id,
          }));
        } else {
          console.log('Error:', data.message);
          return [];
        }
      } else {
        console.log('HTTP Error:', response.statusText);
        return [];
      }
    } catch (error) {
      console.error('Fetch error:', error);
      return [];
    }
  };

  const fetchLeaveApprovers = async (client_id) => {
    const fetch_path = `/client/${client_id}/leaveapprovers`;

    if (!token) {
      console.log('Token is missing');
      return;
    }

    try {
      const response = await newFetch(GET, fetch_path);

      if (response.success) {
        const approvers = response.data.map((item, index) => ({
          id: item.id,
          value: item.type, // Using item.type as value
        }));

        setLeaveApprovers(approvers);
      } else {
        console.log('Error:', response.message);
      }
    } catch (error) {
      console.error('Fetch error:', error);
    }
  };

  const fetchApprovers = async (type) => {
    let api_path = `/associate/${associate_id}/associateapprover/type/${type}`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      const formattedData = {};

      response.data.forEach((item) => {
        if (type === 'claims') {
          formattedData[item.site_approval_id] = {
            site_approval_id: item.site_approval_id,
            source_id: String(item.source_id),
          };
        } else if (type === 'leaves') {
          formattedData[item.client_approval_id] = {
            client_approval_id: item.client_approval_id,
            source_id: String(item.source_id),
          };
        }
      });

      if (type === 'claims') {
        setSelectedApprovers(formattedData);
      } else if (type === 'leaves') {
        setSelectedLeaveApprovers(formattedData);
      }
    } else {
      console.log('Error:', response.message);
    }
  };

  const fetchSiteSettings = async (siteID) => {
    const api_path = `/dashboard/site_settings/site/${siteID}`;
    const response = await newFetch(GET, api_path);
    if (response.success) {
      return response?.data;
    }
  };

  const UpdateApprover = async (type) => {
    let api_path = `/associate/${associate_id}/create-update-associateapprover/type/${type}`;

    let payload;
    if (type === 'claims') {
      payload = selectedApprovers;
    } else if (type === 'leaves') {
      payload = selectedLeaveApprovers;
    } else {
      throw new Error('Invalid approver type');
    }

    try {
      return await newFetch(PUT, api_path, payload);
    } catch (error) {
      console.log(error);
    }
  };

  const UpdateRestDays = async () => {
    let api_path = `/associate/${associate_id}/update-rest-days`;

    const payload = restDays; // Array of selected days: ['Mon', 'Tue', 'Wed', etc.]

    try {
      return await newFetch(PUT, api_path, payload);
    } catch (error) {
      console.log(error);
      throw error;
    }
  };

  const resendInvitesHandler = async () => {
    if (isResendingInvites) return;

    setIsResendingInvites(true);
    try {
      const response = await newFetch(
        POST,
        `/associate/${associate_id}/resend-invites`,
      );

      if (response?.success) {
        ToastUtil.success(response.message);
      } else {
        ToastUtil.error(response?.message || 'Failed to resend invites.');
      }
    } catch (error) {
      ToastUtil.error('Failed to resend invites.');
    } finally {
      setIsResendingInvites(false);
    }
  };

  const deactivateAssociateHandler = async (id) => {
    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to deactivate this employee?',
      )
    ) {
      let api_path = `/associate/${id}/activation/deactivate`;
      let response = await newFetch(PUT, api_path);

      ToastUtil.success(response.message);
      response.success && history.push(`/associates/associate/${id}`);
    }
  };

  const activateAssociateHandler = async (id) => {
    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to activate this employee?',
      )
    ) {
      let api_path = `/associate/${id}/activation/activate`;
      let response = await newFetch(PUT, api_path);

      ToastUtil.success(response.message);
      response.success && history.push(`/associates/associate/${id}`);
    }
  };

  // const pbJOIDNumOnlyHandler = (e) => {
  //   const value = e.target.value.replace(/\D/g, "");
  //   setPBJOID(value);
  // };

  const bhCandIDNumOnlyHandler = (e) => {
    const value = e.target.value.replace(/\D/g, '');
    setBHCandID(value);
  };

  const pbCandIDNumOnlyHandler = (e) => {
    const value = e.target.value.replace(/\D/g, '');
    setPBCandID(value);
  };

  const includesValue = (matrix, value) => {
    for (let i = 0; i < matrix.length; i++) {
      if (matrix[i].role === value) {
        return true;
      }
    }
    return false;
  };

  const submitAssociate = async () => {
    let data = {
      first_name: firstName,
      last_name: lastName,
      employee_no: employeeNo,
      employee_id: employeeID,
      date_of_birth: dateOfBirth,
      password: password,
      email,
      //pb_jo_id: pbJOID,
      pb_cand_id: pbCandID || '',
      bh_cand_id: bhCandID,
      position: position,
      team: team,
      department: department,
      team_lead_id: team_lead_id,
      language,
      last_name_first: isDisplayLastNameFirst ? 1 : 0,
      multipleRoles: multipleRoles,
    };

    data = email === associate.email ? data : { ...data, email };

    const api_path = `/associate/${associate_id}`;

    try {
      return await newFetch(PUT, api_path, data);
    } catch (error) {
      console.log(error);
    }
  };

  const submitOldSiteAssociatesHandler = async () => {
    return await Promise.all(
      await oldSiteAssociates.map(async (siteAssociate) => {
        let api_path = `/associate/${associate_id}/site/${siteAssociate.site_id}/update`;
        let data = {
          start_date: siteAssociate.start_date,
          resign_date: siteAssociate.resign_date,
          last_day_date: siteAssociate.last_day_date,
          is_team_support: siteAssociate.is_team_support ? 1 : 0,
          is_regrettable: siteAssociate.is_regrettable ? 1 : 0,
          is_blue_badge: siteAssociate.is_blue_badge ? 1 : 0,
          is_contract: siteAssociate.is_contract ? 1 : 0,
          active: siteAssociate.active ? 1 : 0,
          claims: claimCreditLimitPercentage,
        };

        try {
          return await newFetch(PUT, api_path, data);
        } catch (error) {
          console.log(error);
        }
      }),
    );

    // return true
  };

  const fetchLeave = async (newPaginationModel, newSortModel) => {
    try {
      setLoadingLeave(true);

      // Use the provided models or fall back to current state
      const currentPaginationModel = newPaginationModel || paginationModel;
      const currentSortModel = newSortModel || sortModel;

      // Default sorting if no sort model is provided
      const sortField =
        currentSortModel.length > 0 ? currentSortModel[0].field : 'updatedAt';
      const sortDirection =
        currentSortModel.length > 0 ? currentSortModel[0].sort : 'desc';

      const api_path = `/associate-leave-summary/${associate_id}`;
      const response = await newFetch(POST, api_path, {
        field: sortField,
        sort: sortDirection,
        page: currentPaginationModel.page,
        pageSize: currentPaginationModel.pageSize,
      });

      if (response.success) {
        setLeaveList(response.data.list);
        setTotalRows(response.data.total_record);
      } else {
        setLeaveList([]);
        setTotalRows(0);
      }
    } catch (error) {
      console.error('Error fetching leave summary:', error);
      setLeaveList([]);
      setTotalRows(0);
    } finally {
      setLoadingLeave(false);
    }
  };

  const submitNewSiteAssociateHandler = async () => {
    let api_path = `/associate/${associate_id}/assignsite`;
    let data = { sites: newSiteAssociates };

    try {
      return await newFetch(POST, api_path, data);
    } catch (error) {
      console.log(error);
    }
  };

  const submitSitesToDeleteHandler = async () => {
    let api_path = `/associate/${associate_id}/sites_remove`;
    let data = { sites: sitesToDelete };

    try {
      return await newFetch(DELETE, api_path, data);
    } catch (error) {
      console.log(error);
    }
  };

  const submitFixedSchedules = async () => {
    const siteIds = siteAssociateArr.map((user) => user.site_id);
    let api_path = `/associate/${associate_id}/fixed_schedule`;
    let data = {
      schedules: newFixedSchedules,
      ids: siteIds,
      sites: oldSiteAssociates,
    };

    try {
      return await newFetch(PUT, api_path, data);
    } catch (error) {
      console.log(error);
    }
  };

  const submitHandler = async (e) => {
    e.preventDefault();

    if (newFixedSchedules) {
      // Check if any team support site has no fixed schedule
      const notFilled = [...oldSiteAssociates, ...newSiteAssociates]
        .filter((site) => site.is_team_support === true)
        .filter((a) => {
          return !newFixedSchedules.some((cd) => cd.site_id === a.site_id);
        });

      if (notFilled.length > 0) {
        ToastUtil.error('Please select at least one fixed schedule.');
        return false;
      }
    }

    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to update this Employee?',
      )
    ) {
      setIsLoading(true);

      let associate_response = await submitAssociate();

      if (associate_response.success) {
        if (oldSiteAssociates.length > 0) {
          const old_sites_response = await submitOldSiteAssociatesHandler();

          if (old_sites_response.find((res) => !res.success)) {
            ToastUtil.error(
              old_sites_response.find((res) => !res.success).message,
            );
          }
        }

        if (newSiteAssociates.length > 0) {
          let new_sites_response = await submitNewSiteAssociateHandler();
          if (!new_sites_response.success)
            ToastUtil.error(new_sites_response.message);
        }

        if (sitesToDelete.length > 0) {
          const response = await submitSitesToDeleteHandler();
          if (!response.success) ToastUtil.error(response.message);
        }

        if (newFixedSchedules) {
          let fixed_schedule_response =
            await submitFixedSchedules(associate_id);
          if (!fixed_schedule_response.success)
            ToastUtil.error(fixed_schedule_response.message);
        }

        if (selectedApprovers) await UpdateApprover('claims');
        if (selectedLeaveApprovers) await UpdateApprover('leaves');

        await UpdateRestDays();

        ToastUtil.success(associate_response.message);

        setIsLoading(false);

        history.goBack();
      } else {
        ToastUtil.error(associate_response.message);
      }
    }
  };

  const init = async () => {
    fetchClients();
    fetchSites();
    fetchShifts();
    fetchAssociateListBySiteID(19);
    fetchLeaveTypesByAssociate();
    fetchAdmins();
    fetchRestDays();
    fetchAssociateScheduleListByAssociateID();
    fetchAppliedLeaves();
    await fetchData();
    await fetchAssociate();
    await fetchSiteAssociates();
    await fetchFixedSchedules();
  };

  const handleSubmit = async (event) => {
    if (siteAssociateArr.length === 0 && siteAssociates.length > 0) {
      event.preventDefault();
      ToastUtil.error('Cannot proceed. Please assign a site.');
      return false;
    }
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      ToastUtil.error('Please fill out the required fields.');
    } else {
      await submitHandler(event);
    }

    setValidated(true);
  };

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {}, [appliedLeaves]);

  useEffect(() => {
    setSiteAssociateArr([...oldSiteAssociates, ...newSiteAssociates]);
    const toDelete = siteAssociates.filter(
      (obj1) =>
        !oldSiteAssociates.some((obj2) => obj1.site_id === obj2.site_id),
    );

    if (toDelete.length > 0) {
      setSitesToDelete(toDelete);
      const uniqueIds = new Set(toDelete.map((item) => item.site_id));
      setNewFixedSchedules((prev) =>
        prev.filter((item) => !uniqueIds.has(item.site_id)),
      );
    }
  }, [oldSiteAssociates, newSiteAssociates]);

  useEffect(() => {
    setData(leaveList !== undefined ? leaveList : []);

    leaveList !== undefined && setLoadingLeave(false);
  }, [leaveList]);

  useEffect(() => {
    const fetchAllClaimApprovers = async () => {
      if (siteAssociateArr && siteAssociateArr.length > 0) {
        // Clear previous claim approvers
        setClaimApprovers([]);

        // Get unique site IDs to prevent duplicate fetching
        const uniqueSiteIds = [
          ...new Set(siteAssociateArr.map((item) => item.site_id)),
        ];

        // Filter out any undefined or null site IDs
        const validSiteIds = uniqueSiteIds.filter((id) => id);

        // Use Promise.all to fetch data for all sites concurrently
        const allApproverArrays = await Promise.all(
          validSiteIds.map((siteId) => fetchClaimApprovers(siteId)),
        );

        const allSiteSettingsArrays = await Promise.all(
          validSiteIds.map((siteId) => fetchSiteSettings(siteId)),
        );

        // Flatten the array of arrays
        const allApprovers = allApproverArrays.flat();
        // Set the state with all approvers at once
        setClaimApprovers(allApprovers);
        setClientSettings(allSiteSettingsArrays);
      }
    };

    fetchAllClaimApprovers();
  }, [siteAssociateArr]);

  useEffect(() => {
    if (claimApprovers && claimApprovers.length > 0) {
      claimApprovers.forEach((approver) => {
        if (approver.value === 'associate' && approver.site_id) {
          fetchAssociateListBySiteID(approver.site_id);
        }
      });
      fetchApprovers('claims');
    }
  }, [claimApprovers]);

  useEffect(() => {
    if (leaveApprovers && leaveApprovers.length > 0) {
      fetchApprovers('leaves');
    }
  }, [leaveApprovers]);

  useEffect(() => {
    if (activeClient) {
      fetchClientUsers();
      fetchAdminsByClient();
      fetchDepartments(activeClient.id);
      fetchLeaveApprovers(activeClient.id);
    }
  }, [activeClient]);

  return (
    <LayoutContext.Consumer>
      {({ activeSidebar }) => (
        <div style={{ paddingTop: '3rem' }}>
          <div
            className="d-flex flex-column"
            style={{ paddingLeft: '3rem', paddingRight: '3rem' }}
          >
            <NavLink
              to={`/associates/associate/${associate_id}`}
              className="text-decoration-none"
              style={{ color: 'inherit' }}
            >
              <div style={{ color: '#0d6efd' }}>
                <i className="fas fa-chevron-left pe-2"></i>{' '}
                {associate.first_name} {associate.last_name}
              </div>
            </NavLink>
            <div className="pt-4">
              <h5>Edit Employee</h5>
            </div>
          </div>
          {isLoading ? (
            <div className="springloader-holder">
              <SpringLoader />
            </div>
          ) : (
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
              <div
                className="border rounded d-flex"
                style={{
                  marginTop: '2rem',
                  marginLeft: '3rem',
                  marginRight: '3rem',
                }}
              >
                <div
                  style={{
                    minWidth: '15rem',
                    width: '15rem',
                    backgroundColor: '#f3f3f3',
                    padding: '2.25rem',
                  }}
                  className="border-right"
                >
                  <strong>Basic Information</strong>
                  <p className="pt-2 text-muted">
                    View and edit employee information
                  </p>
                </div>
                <div
                  className="flex-grow-1 bg-white"
                  style={{ padding: '2.25rem' }}
                >
                  <Row className="mb-3">
                    <Form.Group as={Col} md="6">
                      <Form.Label>
                        <strong>First Name*</strong>
                      </Form.Label>
                      <Form.Control
                        required
                        type="text"
                        name="firstName"
                        value={firstName || ''}
                        placeholder="First name"
                        onChange={(e) => firstNameHandler(e)}
                        maxLength={60}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please enter first name.
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} md="6">
                      <Form.Label>
                        <strong>Last Name*</strong>
                      </Form.Label>
                      <Form.Control
                        required
                        name="lastName"
                        value={lastName || ''}
                        type="text"
                        placeholder="Last name"
                        onChange={(e) => {
                          lastNameHandler(e);
                        }}
                        maxLength={60}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please enter last name.
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>
                  <Row className="mb-3">
                    <Form.Group as={Col} md="6">
                      <Form.Check
                        type={`checkbox`}
                        name="isLastNameFirst"
                        id={`isLastNameFirst`}
                        style={{
                          marginLeft: 10,
                        }}
                      >
                        <Form.Check.Input
                          type={`checkbox`}
                          onChange={(e) => {
                            displayLastNameHandler(e);
                          }}
                          checked={isDisplayLastNameFirst}
                        />
                        <Form.Check.Label
                          style={{
                            marginLeft: 5,
                            fontWeight: 400,
                            fontStyle: 'italic',
                          }}
                        >{`Last Name First`}</Form.Check.Label>
                      </Form.Check>
                    </Form.Group>
                  </Row>
                  <Row className="mb-3">
                    <Form.Group as={Col} md="6">
                      <Form.Label>
                        <strong>BH Candidate ID</strong>
                      </Form.Label>
                      <Form.Control
                        value={bhCandID || ''}
                        placeholder="BH Candidate ID"
                        onChange={bhCandIDNumOnlyHandler}
                        maxLength={10}
                      />
                    </Form.Group>
                    <Form.Group as={Col} md="6">
                      <Form.Label>
                        <strong>PB Candidate ID</strong>
                      </Form.Label>
                      <Form.Control
                        value={pbCandID || ''}
                        placeholder="PB Candidate ID"
                        onChange={pbCandIDNumOnlyHandler}
                        maxLength={10}
                      />
                    </Form.Group>
                    <Form.Group as={Col} md="6">
                      <Form.Label>&nbsp;</Form.Label>
                    </Form.Group>
                  </Row>
                  <Row className="mb-3">
                    <Form.Group as={Col} md="6">
                      <Form.Label>
                        <strong>Employee No.*</strong>
                      </Form.Label>
                      <Form.Control
                        required
                        name="employeeNo"
                        value={employeeNo || ''}
                        type="text"
                        placeholder="Employee No"
                        onChange={(e) => employeeNoHandler(e)}
                        maxLength={12}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please enter employee no.
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} md="6">
                      <Form.Label>
                        <strong>Employee ID</strong>
                      </Form.Label>
                      <Form.Control
                        name="employeeID"
                        value={employeeID || ''}
                        type="text"
                        placeholder="Employee ID"
                        onChange={(e) => employeeIDHandler(e)}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please enter employee id.
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>
                  <Row className="mb-3">
                    <Form.Group as={Col} md="12">
                      <strong>Date Of Birth*</strong>
                      <Form.Control
                        type="text"
                        name="dateOfBirth"
                        value={dateOfBirth || ''}
                        required
                        onChange={(e) => dateOfBirthHandler(e)}
                        hidden
                      />
                      <DatePicker
                        minDate={new Date(1900, 0, 1)}
                        maxDate={new Date()}
                        hideIfNoPrevNext={true}
                        dateFormat="dd MMMM yyyy"
                        openToDate={
                          startDate || new Date(new Date().getFullYear(), 0, 1)
                        }
                        renderCustomHeader={({
                          date,
                          changeYear,
                          changeMonth,
                        }) => (
                          <div
                            style={{
                              margin: 10,
                              display: 'flex',
                              justifyContent: 'center',
                            }}
                          >
                            <select
                              aria-label="Birth year"
                              value={date.getFullYear()}
                              onChange={({ target: { value } }) =>
                                changeYear(Number(value))
                              }
                              className="me-2"
                            >
                              {Array.from(
                                { length: new Date().getFullYear() - 1900 + 1 },
                                (_, index) => new Date().getFullYear() - index,
                              ).map((year) => (
                                <option key={year} value={year}>
                                  {year}
                                </option>
                              ))}
                            </select>
                            <select
                              value={monthValue ?? ''}
                              onChange={({ target: { value } }) => {
                                changeMonth(months.indexOf(value));
                                setMonthValue(value);
                              }}
                            >
                              {months.map((option, index) => (
                                <option key={index} value={option}>
                                  {option}
                                </option>
                              ))}
                            </select>
                          </div>
                        )}
                        selected={startDate}
                        onChange={(date) => {
                          setStartDate(date === null ? new Date() : date);
                          setDateOfBirth(date === null ? new Date() : date);
                        }}
                        className={`form-control `}
                        required
                      />
                      <Form.Control.Feedback type="invalid">
                        Please enter date of birth.
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>
                  <Row className="mb-3">
                    <Form.Group as={Col} md="12">
                      <Form.Label>
                        <strong>Email*</strong>
                      </Form.Label>
                      <Form.Control
                        required
                        name="email"
                        value={email}
                        type="email"
                        placeholder="Email"
                        onChange={(e) => emailHandler(e)}
                        maxLength={100}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please enter valid email.
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>
                </div>
              </div>
              <div
                className="border rounded d-flex"
                style={{
                  marginTop: '2rem',
                  marginLeft: '3rem',
                  marginRight: '3rem',
                  marginBottom: siteAssociates.find(
                    (siteAssociate) => siteAssociate.is_team_support,
                  )
                    ? '0'
                    : '1rem',
                }}
              >
                <div
                  style={{
                    minWidth: '15rem',
                    width: '15rem',
                    backgroundColor: '#f3f3f3',
                    padding: '2.25rem',
                  }}
                  className="border-right"
                >
                  <strong>Assigned To</strong>
                  <p className="pt-2 text-muted">
                    Manage client and site assignation
                  </p>
                </div>
                <div
                  className="flex-grow-1 bg-white"
                  style={{ padding: '2.25rem' }}
                >
                  <Row className="mb-3">
                    <Form.Group as={Col} md="12">
                      <strong>Client*</strong>
                      <Form.Control
                        as="select"
                        required
                        type="select"
                        value={activeClient?.id ?? ''}
                        onChange={(e) => clientHandler(e)}
                      >
                        <option value="no-value" disabled>
                          Select Client
                        </option>
                        {clients &&
                          clients.map((client) => (
                            <option key={client.id} value={client.id}>
                              {client.name}
                            </option>
                          ))}
                      </Form.Control>
                      <Form.Control.Feedback type="invalid">
                        Please select a client.
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>
                  <Row className="mb-3">
                    <Form.Group as={Col} md="12">
                      <strong>Add Sites*</strong>
                      <Form.Control
                        as="select"
                        type="select"
                        value=""
                        onChange={siteHandler}
                      >
                        <option value="" disabled>
                          Select Site
                        </option>
                        {activeClient &&
                          sites
                            .filter((site) => site.active === true)
                            .map(
                              (site) =>
                                site.client_id === activeClient.id && (
                                  <option
                                    key={site.id}
                                    value={JSON.stringify(site)}
                                  >
                                    {site.name}
                                  </option>
                                ),
                            )}
                      </Form.Control>
                    </Form.Group>
                    <div className="col-sm-12">
                      {showOldSites &&
                        oldSiteAssociates &&
                        oldSiteAssociates.map((siteAssociate, index) => {
                          // Check if there's any schedule for this site with status != 1
                          const hasActiveSchedules = Array.isArray(scheduleList)
                            ? scheduleList.some(
                                (schedule) =>
                                  schedule.site_id === siteAssociate.site_id &&
                                  schedule.status !== 1,
                              )
                            : false;

                          return (
                            <div
                              key={`${siteAssociate.id}${index}`}
                              className="pt-3"
                            >
                              <div className="d-flex justify-content-between">
                                <strong>
                                  {getSiteNameById(siteAssociate.site_id)}
                                </strong>

                                {/* Conditionally show Remove only if all statuses = 1 */}
                                {!hasActiveSchedules && (
                                  <p
                                    style={{ cursor: 'pointer' }}
                                    className="text-danger"
                                    onClick={(e) =>
                                      removeOldSiteAssociate(e, index)
                                    }
                                  >
                                    Remove
                                  </p>
                                )}
                              </div>

                              <div
                                className="border rounded mt-2"
                                style={{ padding: '2.25rem' }}
                              >
                                <Row>
                                  <div className="col-sm-12">
                                    <div
                                      style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                      }}
                                    >
                                      <label
                                        className="switch"
                                        style={{
                                          marginRight: 10,
                                        }}
                                      >
                                        <input
                                          type="checkbox"
                                          onChange={(e) =>
                                            oldActiveHandler(index, e)
                                          }
                                          checked={
                                            siteAssociate &&
                                            siteAssociate.active
                                          }
                                        />
                                        <span className="slider round"></span>
                                      </label>
                                      <strong>Enable or Disable?</strong>
                                    </div>
                                    <p>
                                      It will enable/disable this client site on
                                      this employee.
                                    </p>
                                  </div>

                                  <Form.Group as={Col} md="6">
                                    <strong>Start Date*</strong>
                                    <Form.Control
                                      type="date"
                                      value={siteAssociate.start_date}
                                      onChange={(e) =>
                                        oldStartDateHandler(index, e)
                                      }
                                      required
                                      disabled={
                                        siteAssociate && !siteAssociate.active
                                      }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                      Please enter start date.
                                    </Form.Control.Feedback>
                                  </Form.Group>

                                  <div
                                    className="col-sm-6"
                                    style={{
                                      display: 'flex',
                                      flexDirection: 'row',
                                      marginTop: 30,
                                    }}
                                  >
                                    <label
                                      className="switch"
                                      style={{
                                        marginRight: 10,
                                      }}
                                    >
                                      <input
                                        type="checkbox"
                                        onChange={(e) =>
                                          oldTeamSupportHandler(index, e)
                                        }
                                        checked={
                                          siteAssociate &&
                                          siteAssociate.is_team_support
                                        }
                                        disabled={
                                          siteAssociate && !siteAssociate.active
                                        }
                                      />
                                      <span className="slider round"></span>
                                    </label>
                                    <strong>Fixed Shift?</strong>
                                  </div>
                                </Row>

                                <Row style={{ marginTop: 10 }}>
                                  <Form.Group as={Col} md="6">
                                    <strong>Resign Date</strong>
                                    <Form.Control
                                      type="date"
                                      value={siteAssociate.resign_date || ''}
                                      onChange={(e) =>
                                        oldResignDateHandler(index, e)
                                      }
                                      disabled={
                                        siteAssociate && !siteAssociate.active
                                      }
                                    />
                                  </Form.Group>

                                  <Form.Group as={Col} md="6">
                                    <strong>Last Day Date</strong>
                                    <Form.Control
                                      type="date"
                                      value={siteAssociate.last_day_date || ''}
                                      onChange={(e) =>
                                        oldLastDayDateHandler(index, e)
                                      }
                                      disabled={
                                        siteAssociate && !siteAssociate.active
                                      }
                                    />
                                  </Form.Group>
                                </Row>

                                {siteAssociate.last_day_date && (
                                  <div className="row pt-4">
                                    <div
                                      className="col-sm-4"
                                      style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        marginTop: 30,
                                      }}
                                    >
                                      <label
                                        className="switch"
                                        style={{
                                          marginRight: 10,
                                        }}
                                      >
                                        <input
                                          type="checkbox"
                                          onChange={(e) =>
                                            oldRegrettableHandler(index, e)
                                          }
                                          checked={
                                            siteAssociate &&
                                            siteAssociate.is_regrettable
                                          }
                                          disabled={
                                            siteAssociate &&
                                            !siteAssociate.active
                                          }
                                        />
                                        <span className="slider round"></span>
                                      </label>
                                      <strong>Regrettable?</strong>
                                    </div>

                                    <div
                                      className="col-sm-4"
                                      style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        marginTop: 30,
                                      }}
                                    >
                                      <label
                                        className="switch"
                                        style={{
                                          marginRight: 10,
                                        }}
                                      >
                                        <input
                                          type="checkbox"
                                          onChange={(e) =>
                                            oldContractHandler(index, e)
                                          }
                                          checked={
                                            siteAssociate &&
                                            siteAssociate.is_contract
                                          }
                                          disabled={
                                            siteAssociate &&
                                            !siteAssociate.active
                                          }
                                        />
                                        <span className="slider round"></span>
                                      </label>
                                      <strong>Contract?</strong>
                                    </div>

                                    <div
                                      className="col-sm-4"
                                      style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        marginTop: 30,
                                      }}
                                    >
                                      <label
                                        className="switch"
                                        style={{
                                          marginRight: 10,
                                        }}
                                      >
                                        <input
                                          type="checkbox"
                                          onChange={(e) =>
                                            oldBlueBadgeHandler(index, e)
                                          }
                                          checked={
                                            siteAssociate &&
                                            siteAssociate.is_blue_badge
                                          }
                                          disabled={
                                            siteAssociate &&
                                            !siteAssociate.active
                                          }
                                        />
                                        <span className="slider round"></span>
                                      </label>
                                      <strong>Blue Badge?</strong>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          );
                        })}

                      {newSiteAssociates &&
                        newSiteAssociates.map((siteAssociate, index) => (
                          <div key={siteAssociate.id + index} className="pt-3">
                            <div className="d-flex justify-content-between">
                              <strong>
                                {getSiteNameById(siteAssociate.site_id)}
                              </strong>
                              <p
                                style={{ cursor: 'pointer' }}
                                className="text-danger"
                                onClick={() => removeSiteAssociate(index)}
                              >
                                Remove
                              </p>
                            </div>
                            <div
                              className="border rounded mt-2"
                              style={{ padding: '2.25rem' }}
                            >
                              <Row>
                                <div className="col-sm-12">
                                  <div
                                    style={{
                                      display: 'flex',
                                      flexDirection: 'row',
                                    }}
                                  >
                                    <label
                                      className="switch"
                                      style={{
                                        marginRight: 10,
                                      }}
                                    >
                                      <input
                                        type="checkbox"
                                        onChange={(e) =>
                                          newActiveHandler(index, e)
                                        }
                                        checked={
                                          siteAssociate && siteAssociate.active
                                        }
                                      />
                                      <span className="slider round"></span>
                                    </label>
                                    <strong>Enable or Disable?</strong>
                                  </div>
                                  <p>
                                    It will enable/disable this client site on
                                    this employee.
                                  </p>
                                </div>
                                <Form.Group as={Col} md="6">
                                  <strong>Start Date*</strong>
                                  <Form.Control
                                    type="date"
                                    value={siteAssociate.start_date || ''}
                                    onChange={(e) =>
                                      newStartDateHandler(index, e)
                                    }
                                    disabled={
                                      siteAssociate && !siteAssociate.active
                                    }
                                    required
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    Please enter start date.
                                  </Form.Control.Feedback>
                                </Form.Group>
                                <div
                                  className="col-sm-6"
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    marginTop: 30,
                                  }}
                                >
                                  <label
                                    className="switch"
                                    style={{
                                      marginRight: 10,
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      onChange={(e) =>
                                        newTeamSupportHandler(index, e)
                                      }
                                      checked={
                                        siteAssociate &&
                                        siteAssociate.is_team_support
                                      }
                                      disabled={
                                        siteAssociate && !siteAssociate.active
                                      }
                                    />
                                    <span className="slider round"></span>
                                  </label>
                                  <strong>Fixed Shift?</strong>
                                </div>
                              </Row>
                              <Row style={{ marginTop: 10 }}>
                                <Form.Group as={Col} md="6">
                                  <strong>Resign Date</strong>
                                  <Form.Control
                                    type="date"
                                    value={siteAssociate.resign_date || ''}
                                    onChange={(e) =>
                                      newResignDateHandler(index, e)
                                    }
                                    disabled={
                                      siteAssociate && !siteAssociate.active
                                    }
                                  />
                                </Form.Group>
                                <Form.Group as={Col} md="6">
                                  <strong>Last Day Date</strong>
                                  <Form.Control
                                    type="date"
                                    value={siteAssociate.last_day_date || ''}
                                    onChange={(e) =>
                                      newLastDayDateHandler(index, e)
                                    }
                                    disabled={
                                      siteAssociate && !siteAssociate.active
                                    }
                                  />
                                </Form.Group>
                              </Row>
                              {siteAssociate.last_day_date && (
                                <div className="row pt-4">
                                  <div
                                    className="col-sm-4"
                                    style={{
                                      display: 'flex',
                                      flexDirection: 'row',
                                      marginTop: 30,
                                    }}
                                  >
                                    <label
                                      className="switch"
                                      style={{
                                        marginRight: 10,
                                      }}
                                    >
                                      <input
                                        type="checkbox"
                                        onChange={(e) =>
                                          newRegrettableHandler(index, e)
                                        }
                                        checked={
                                          siteAssociate &&
                                          siteAssociate.is_regrettable
                                        }
                                        disabled={
                                          siteAssociate && !siteAssociate.active
                                        }
                                      />
                                      <span className="slider round"></span>
                                    </label>
                                    <strong>Regrettable?</strong>
                                  </div>
                                  <div
                                    className="col-sm-4"
                                    style={{
                                      display: 'flex',
                                      flexDirection: 'row',
                                      marginTop: 30,
                                    }}
                                  >
                                    <label
                                      className="switch"
                                      style={{
                                        marginRight: 10,
                                      }}
                                    >
                                      <input
                                        type="checkbox"
                                        onChange={(e) =>
                                          newContractHandler(index, e)
                                        }
                                        checked={
                                          siteAssociate &&
                                          siteAssociate.is_contract
                                        }
                                        disabled={
                                          siteAssociate && !siteAssociate.active
                                        }
                                      />
                                      <span className="slider round"></span>
                                    </label>
                                    <strong>Contract?</strong>
                                  </div>
                                  <div
                                    className="col-sm-4"
                                    style={{
                                      display: 'flex',
                                      flexDirection: 'row',
                                      marginTop: 30,
                                    }}
                                  >
                                    <label
                                      className="switch"
                                      style={{
                                        marginRight: 10,
                                      }}
                                    >
                                      <input
                                        type="checkbox"
                                        onChange={(e) =>
                                          newBlueBadgeHandler(index, e)
                                        }
                                        checked={
                                          siteAssociate &&
                                          siteAssociate.is_blue_badge
                                        }
                                        disabled={
                                          siteAssociate && !siteAssociate.active
                                        }
                                      />
                                      <span className="slider round"></span>
                                    </label>
                                    <strong>Blue Badge?</strong>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        ))}
                    </div>
                  </Row>
                  <Row>
                    <Form.Group as={Col} md="12">
                      <strong>Team</strong>
                      <Form.Control
                        as="select"
                        type="select"
                        onChange={(e) => TeamHandler(e)}
                        value={team || ''}
                      >
                        <option value="">Select Team</option>
                        {teamList &&
                          teamList.map((item) => (
                            <option key={item.value} value={item.value}>
                              {item.label}
                            </option>
                          ))}
                      </Form.Control>
                    </Form.Group>
                  </Row>
                  <Row>
                    <Form.Group
                      as={Col}
                      md="4"
                      style={{
                        marginTop: 10,
                      }}
                    >
                      <strong>Department</strong>
                      <Form.Control
                        as="select"
                        type="select"
                        onChange={(e) => DepartmentHandler(e)}
                        value={department ?? ''}
                      >
                        <option value="">Select Department</option>
                        {departmentList &&
                          departmentList.map((item) => (
                            <option key={item.value} value={item.value}>
                              {item.label}
                            </option>
                          ))}
                      </Form.Control>
                    </Form.Group>
                  </Row>
                  <Row className="mb-3">
                    <Form.Group
                      as={Col}
                      md="4"
                      style={{
                        marginTop: 10,
                      }}
                    >
                      <strong>Team Lead</strong>
                      <Form.Control
                        as="select"
                        type="select"
                        onChange={(e) => TeamLeadIDHandler(e)}
                        value={team_lead_id ?? ''}
                      >
                        <option value="">Select Team Lead</option>
                        {filterApproversBySites(
                          [...admins, ...clientUsers],
                          siteAssociateArr.map(
                            (siteAssociate) => siteAssociate.site_id,
                          ),
                        ).map((item) => (
                            <option key={item.id} value={item.id}>
                              {item.first_name} {item.last_name}
                            </option>
                          ))}
                      </Form.Control>
                    </Form.Group>
                  </Row>
                </div>
              </div>
              {[...oldSiteAssociates, ...newSiteAssociates].find(
                (siteAssociate) => siteAssociate.is_team_support,
              ) && (
                <div
                  className="border rounded d-flex"
                  style={{
                    marginTop: '2rem',
                    marginLeft: '3rem',
                    marginRight: '3rem',
                    marginBottom: '1rem',
                  }}
                >
                  <div
                    style={{
                      minWidth: '15rem',
                      width: '15rem',
                      backgroundColor: '#f3f3f3',
                      padding: '2.25rem',
                    }}
                  >
                    <strong>Fixed Schedule</strong>
                    <p className="pt-2 text-muted">
                      Manage fixed schedule for employees as Team Support
                    </p>
                  </div>
                  <div
                    className="flex-grow-1 bg-white"
                    style={{ padding: '2.25rem' }}
                  >
                    {activeClient && (
                      <div className="row">
                        <div className="col-sm-12">
                          <table className="table table-bordered">
                            <thead>
                              <tr>
                                <th className="border-bottom-0"></th>
                                {toWeekDaysArrayFull(
                                  moment(),
                                  activeClient.start_day,
                                ).map((day) => (
                                  <th key={day} className="border-bottom-0">
                                    {moment(day).format('ddd')}
                                  </th>
                                ))}
                              </tr>
                            </thead>
                            <tbody>
                              {[...oldSiteAssociates, ...newSiteAssociates].map(
                                (site) =>
                                  site.is_team_support && (
                                    <React.Fragment key={site.site_id}>
                                      <tr>
                                        <td colSpan="8">
                                          <b>{getSiteNameById(site.site_id)}</b>
                                        </td>
                                      </tr>
                                      {shifts &&
                                        shifts
                                          // .sort((a, b) => (a.name > b.name ? 1 : -1))
                                          .filter(
                                            (shift) => shift.status === true,
                                          )
                                          .map(
                                            (shift, index) =>
                                              shift.site_id ===
                                                site.site_id && (
                                                <tr key={index}>
                                                  <td
                                                    style={{
                                                      whiteSpace: 'nowrap',
                                                    }}
                                                  >{`${shift.name} (${to12Hr(
                                                    shift.start_time,
                                                  )}-${to12Hr(
                                                    shift.end_time,
                                                  )})`}</td>
                                                  {toWeekDaysArrayFull(
                                                    moment(),
                                                    activeClient.start_day,
                                                  ).map((day, index) => (
                                                    <td
                                                      className="text-center"
                                                      key={day}
                                                    >
                                                      <input
                                                        type="checkbox"
                                                        value={shift.id}
                                                        checked={newFixedSchedules.some(
                                                          (schedule) =>
                                                            schedule.day ===
                                                              day.day() &&
                                                            schedule.shift_id ===
                                                              shift.id,
                                                        )}
                                                        onChange={(e) =>
                                                          fixedScheduleCheckboxHandler(
                                                            day.day(),
                                                            shift.id,
                                                            site.site_id,
                                                            e,
                                                          )
                                                        }
                                                        className="ms-1 form-check-input position-static"
                                                      />
                                                    </td>
                                                  ))}
                                                </tr>
                                              ),
                                          )}
                                    </React.Fragment>
                                  ),
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}
              {activeClient && activeClient.enable_claims === true && (
                <div
                  className="border rounded d-flex"
                  style={{
                    marginTop: '2rem',
                    marginLeft: '3rem',
                    marginRight: '3rem',
                    marginBottom: '1rem',
                  }}
                >
                  <div
                    style={{
                      minWidth: '15rem',
                      width: '15rem',
                      backgroundColor: '#f3f3f3',
                      padding: '2.25rem',
                    }}
                    className="border-right"
                  >
                    <strong>Claims</strong>
                    <p className="pt-2 text-muted">
                      Assign limits, percentage and approvers of claims.
                    </p>
                  </div>
                  <div
                    className="flex-grow-1 bg-white"
                    style={{ padding: '2.25rem' }}
                  >
                    <Card className="mb-4">
                      <CardHeader>
                        <strong>Staff Purchase Settings</strong>
                      </CardHeader>
                      <CardBody>
                        {clientSettings.length > 0 &&
                          clientSettings.map((item, index) => {
                            const siteData = claimCreditLimitPercentage.find(
                              (s) => s.site === item.id,
                            );

                            return (
                              <Row key={`${item.id}-${index}`} className="mb-4">
                                <strong className="fw-bold">{item.name}</strong>

                                {item?.enable_claim_limit && (
                                  <Form.Group as={Col} md="4">
                                    <Form.Label>
                                      <strong className="text-muted">
                                        Credit Limit
                                      </strong>
                                    </Form.Label>
                                    <Form.Control
                                      required
                                      name="credit_limit"
                                      value={siteData?.creditLimit ?? ''}
                                      type="text"
                                      placeholder="Credit Limit"
                                      onChange={(e) =>
                                        claimCreditLimitPercentageHandler(
                                          e,
                                          'credit limit',
                                          item.id,
                                        )
                                      }
                                      maxLength={12}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                      Please enter credit limit.
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                )}

                                {item?.enable_claim_percentage && (
                                  <Form.Group as={Col} md="4">
                                    <Form.Label>
                                      <strong className="text-muted">
                                        Credit Percentage (%)
                                      </strong>
                                    </Form.Label>
                                    <Form.Control
                                      required
                                      name="credit_percentage"
                                      value={siteData?.creditPercentage ?? ''}
                                      type="text"
                                      placeholder="Credit Percentage"
                                      onChange={(e) =>
                                        claimCreditLimitPercentageHandler(
                                          e,
                                          'credit percentage',
                                          item.id,
                                        )
                                      }
                                      maxLength={12}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                      Please enter credit percentage.
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                )}

                                {item?.enable_claim_receipt && (
                                  <Form.Group as={Col} md="4">
                                    <Form.Label>
                                      <strong className="text-muted">
                                        No. of Claim Receipts
                                      </strong>
                                    </Form.Label>
                                    <Form.Control
                                      required
                                      name="claim_no_receipts"
                                      value={siteData?.claimNoReceipts ?? ''}
                                      type="text"
                                      placeholder="No. of Claim Receipts"
                                      onChange={(e) =>
                                        claimCreditLimitPercentageHandler(
                                          e,
                                          'no of receipts',
                                          item.id,
                                        )
                                      }
                                      maxLength={12}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                      Please enter credit percentage.
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                )}

                                {!item?.enable_claim_limit &&
                                  !item?.enable_claim_percentage && (
                                    <p className="text-muted">
                                      Credit Limits & Percentage for Claims
                                      Settings are disabled.
                                    </p>
                                  )}
                              </Row>
                            );
                          })}
                      </CardBody>
                    </Card>

                    <Card className="mb-4">
                      <CardHeader>
                        <strong>Safety Shoes Settings</strong>
                      </CardHeader>
                      <CardBody>
                        {clientSettings.length > 0 &&
                          clientSettings.map((item, index) => {
                            const siteData = claimCreditLimitPercentage.find(
                              (s) => s.site === item.id,
                            );

                            return (
                              <Row key={`${item.id}-${index}`} className="mb-4">
                                <strong className="fw-bold">{item.name}</strong>

                                {item?.enable_ss_claim_limit && (
                                  <Form.Group as={Col} md="4">
                                    <Form.Label>
                                      <strong className="text-muted">
                                        Safety Shoes Credit Limit
                                      </strong>
                                    </Form.Label>
                                    <Form.Control
                                      required
                                      name="ss_credit_limit"
                                      value={
                                        siteData?.safetyShoesCreditLimit ?? ''
                                      }
                                      type="text"
                                      placeholder="Safety Shoes Credit Limit"
                                      onChange={(e) =>
                                        claimCreditLimitPercentageHandler(
                                          e,
                                          'safety shoes credit limit',
                                          item.id,
                                        )
                                      }
                                      maxLength={12}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                      Please enter safety shoes credit limit.
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                )}

                                {!item?.enable_ss_claim_limit && (
                                  <p className="text-muted">
                                    Safety Shoes Credit Limits for Claims
                                    Settings are disabled.
                                  </p>
                                )}
                              </Row>
                            );
                          })}
                      </CardBody>
                    </Card>
                    <Card className="mb-4">
                      <Card.Header>
                        <strong>Approvers</strong>
                      </Card.Header>
                      <Card.Body>
                        {claimApprovers && claimApprovers.length > 0 ? (
                          Object.entries(
                            claimApprovers.reduce((acc, approver) => {
                              acc[approver.name] = acc[approver.name] || [];
                              acc[approver.name].push(approver);
                              return acc;
                            }, {}),
                          )
                            .sort(([siteNameA], [siteNameB]) =>
                              siteNameA.localeCompare(siteNameB),
                            ) // site names ASC
                            .map(([siteName, approvers]) => (
                              <div
                                key={siteName}
                                className="mb-4 p-3 border rounded col-md-8"
                              >
                                <h5 className="fw-bold">{siteName}</h5>
                                {approvers.map((approver, index) => (
                                  <Row
                                    key={approver.id}
                                    className="align-items-center mb-2"
                                  >
                                    <Col md={3} className="fw-bold">
                                      Approver {index + 1}
                                    </Col>
                                    <Col md={9}>
                                      <Form.Group
                                        controlId={`approver-${approver.id}`}
                                      >
                                        <Form.Label className="fw-semibold">
                                          {approver.value
                                            .charAt(0)
                                            .toUpperCase() +
                                            approver.value.slice(1)}{' '}
                                          *
                                        </Form.Label>
                                        <Form.Control
                                          as="select"
                                          required
                                          value={
                                            selectedApprovers[
                                              approver.id
                                            ]?.source_id?.toString() || ''
                                          }
                                          onChange={(e) =>
                                            handleApproverChange(
                                              approver.id,
                                              e.target.value,
                                            )
                                          }
                                        >
                                          <option value="">Select</option>

                                          {/* Client Users */}
                                          {approver.value === 'client' &&
                                            filterApproversBySites(
                                              clientUsers,
                                              [approver.site_id],
                                            )
                                              ?.slice()
                                              .sort((a, b) =>
                                                `${a.first_name} ${a.last_name}`.localeCompare(
                                                  `${b.first_name} ${b.last_name}`,
                                                ),
                                              )
                                              .map((user) => (
                                                <option
                                                  key={user.id}
                                                  value={user.id}
                                                >
                                                  {user.first_name}{' '}
                                                  {user.last_name}
                                                </option>
                                              ))}

                                          {/* Associates */}
                                          {approver.value === 'associate' &&
                                            associateList
                                              ?.slice()
                                              .sort((a, b) =>
                                                `${a.first_name} ${a.last_name}`.localeCompare(
                                                  `${b.first_name} ${b.last_name}`,
                                                ),
                                              )
                                              .map((associate) => (
                                                <option
                                                  key={associate.id}
                                                  value={associate.id}
                                                >
                                                  {associate.first_name}{' '}
                                                  {associate.last_name}
                                                </option>
                                              ))}

                                          {/* Admins */}
                                          {approver.value === 'admin' &&
                                            filterApproversBySites(admins, [
                                              approver.site_id,
                                            ])
                                              ?.slice()
                                              .sort((a, b) =>
                                                `${a.first_name} ${a.last_name}`.localeCompare(
                                                  `${b.first_name} ${b.last_name}`,
                                                ),
                                              )
                                              .map((admin) => (
                                                <option
                                                  key={admin.id}
                                                  value={admin.id}
                                                >
                                                  {admin.first_name}{' '}
                                                  {admin.last_name}
                                                </option>
                                              ))}
                                        </Form.Control>
                                        <Form.Control.Feedback type="invalid">
                                          Please select an approver.
                                        </Form.Control.Feedback>
                                      </Form.Group>
                                    </Col>
                                  </Row>
                                ))}
                              </div>
                            ))
                        ) : (
                          <div
                            className="text-center p-4"
                            style={{ marginTop: '20px' }}
                          >
                            No Records Found
                          </div>
                        )}
                      </Card.Body>
                    </Card>
                  </div>
                </div>
              )}
              {activeClient && activeClient.enable_leave_credits === true && (
                <div
                  className="border rounded d-flex"
                  style={{
                    marginTop: '2rem',
                    marginLeft: '3rem',
                    marginRight: '3rem',
                    marginBottom: '1rem',
                  }}
                >
                  <div
                    style={{
                      minWidth: '15rem',
                      width: '15rem',
                      backgroundColor: '#f3f3f3',
                      padding: '2.25rem',
                    }}
                    className="border-right"
                  >
                    <strong>Leaves</strong>
                    <p className="pt-2 text-muted">
                      Assign leave credits and designate leave approvers.
                    </p>
                  </div>
                  <div
                    className="flex-grow-1 bg-white"
                    style={{ padding: '2.25rem' }}
                  >
                    <Card className="mb-4">
                      <CardHeader className="d-flex justify-content-between align-items-center">
                        <strong>Leave Summary</strong>
                        <button
                          onClick={(e) => handleAddNewLeaveType(e)}
                          className="btn btn-brand rounded me-2 adjust-fs adjust-shadow ms-auto"
                          style={{ width: '200px' }}
                        >
                          Add New
                        </button>
                      </CardHeader>

                      <CardBody>
                        <div className="table-responsive rounded shadow bg-white">
                          <Box sx={{ width: '100%' }}>
                            <DataGrid
                              columns={leaveColumns}
                              rows={data || []}
                              rowCount={totalRows || 1}
                              loading={loadingLeave}
                              pageSizeOptions={[10, 20, 30, 40, 50, 80, 100]}
                              paginationModel={paginationModel}
                              paginationMode="server"
                              onPaginationModelChange={(newPaginationModel) => {
                                setPaginationModel(newPaginationModel);
                                fetchLeave(newPaginationModel, sortModel);
                              }}
                              sortModel={sortModel}
                              sortingMode="server"
                              onSortModelChange={(newSortModel) => {
                                setSortModel(newSortModel);
                                fetchLeave(paginationModel, newSortModel);
                              }}
                              disableSelectionOnClick
                              isRowSelectable={() => false}
                            />
                          </Box>
                        </div>
                      </CardBody>
                    </Card>
                    <Card className="mb-4">
                      <CardHeader className="d-flex justify-content-between align-items-center">
                        <strong>Leave Details</strong>
                      </CardHeader>

                      <CardBody>
                        <div className="table-responsive rounded shadow-sm bg-white p-3">
                          <Box
                            sx={{
                              width: '100%',
                              '& .MuiDataGrid-root': {
                                border: 'none',
                                fontFamily: 'Inter, Roboto, sans-serif',
                                fontSize: '0.9rem',
                              },
                              '& .MuiDataGrid-cell': {
                                padding: '10px 16px',
                                lineHeight: 1.6,
                                whiteSpace: 'normal',
                                wordBreak: 'break-word',
                              },
                              '& .MuiDataGrid-columnHeaders': {
                                backgroundColor: '#f8f9fa',
                                color: '#495057',
                                fontWeight: 600,
                                fontSize: '0.95rem',
                                letterSpacing: '0.02em',
                              },
                              '& .MuiDataGrid-columnHeaderTitle': {
                                textOverflow: 'clip',
                                whiteSpace: 'normal',
                                lineHeight: 1.2,
                              },
                              '& .MuiDataGrid-row:hover': {
                                backgroundColor: '#f5f5f5',
                              },
                              '& .MuiDataGrid-footerContainer': {
                                backgroundColor: '#f8f9fa',
                              },
                              '& .MuiTablePagination-root': {
                                color: '#495057',
                              },
                            }}
                          >
                            <DataGrid
                              columns={leaveDetailColumns.map((col) => ({
                                ...col,
                                headerAlign: 'center',
                                align: col.type === 'number' ? 'right' : 'left',
                              }))}
                              rows={appliedLeaves || []}
                              loading={loadingLeave}
                              pageSizeOptions={[10, 20, 30, 40, 50, 80, 100]}
                              initialState={{
                                pagination: {
                                  paginationModel: { pageSize: 10, page: 0 },
                                },
                              }}
                              disableSelectionOnClick
                              isRowSelectable={() => false}
                              autoHeight
                              getRowHeight={() => 'auto'}
                            />
                          </Box>
                        </div>
                      </CardBody>
                    </Card>
                    <Card className="mb-4">
                      <Card.Header>
                        <strong>Approvers</strong>
                      </Card.Header>
                      <Card.Body>
                        {leaveApprovers && leaveApprovers.length > 0 ? (
                          <div className="mb-4 p-3 border rounded col-md-8">
                            {leaveApprovers.map((approver, index) => (
                              <Row
                                key={approver.id}
                                className="align-items-center mb-3"
                              >
                                <Col md={3} className="fw-bold">
                                  Approver {index + 1}
                                </Col>
                                <Col md={9}>
                                  <Form.Group
                                    controlId={`leave-approver-${approver.id}`}
                                  >
                                    <Form.Label className="fw-semibold">
                                      {approver.value.charAt(0).toUpperCase() +
                                        approver.value.slice(1)}{' '}
                                      *
                                    </Form.Label>
                                    <Form.Control
                                      as="select"
                                      required
                                      value={
                                        selectedLeaveApprovers[
                                          approver.id
                                        ]?.source_id?.toString() || ''
                                      }
                                      onChange={(e) =>
                                        handleLeaveApproverChange(
                                          approver.id,
                                          e.target.value,
                                        )
                                      }
                                    >
                                      <option value="">Select</option>

                                      {/* Client Users */}
                                      {approver.value === 'client' &&
                                        filterApproversBySites(
                                          clientUsers,
                                          siteAssociateArr.map(
                                            (siteAssociate) =>
                                              siteAssociate.site_id,
                                          ),
                                        )
                                          ?.slice()
                                          .sort((a, b) =>
                                            `${a.first_name} ${a.last_name}`.localeCompare(
                                              `${b.first_name} ${b.last_name}`,
                                            ),
                                          )
                                          .map((user) => (
                                            <option
                                              key={user.id}
                                              value={user.id}
                                            >
                                              {user.first_name} {user.last_name}
                                            </option>
                                          ))}

                                      {/* Associates */}
                                      {approver.value === 'associate' &&
                                        associateList
                                          ?.slice()
                                          .sort((a, b) =>
                                            `${a.first_name} ${a.last_name}`.localeCompare(
                                              `${b.first_name} ${b.last_name}`,
                                            ),
                                          )
                                          .map((associate) => (
                                            <option
                                              key={associate.id}
                                              value={associate.id}
                                            >
                                              {associate.first_name}{' '}
                                              {associate.last_name}
                                            </option>
                                          ))}

                                      {/* Admins */}
                                      {approver.value === 'admin' &&
                                        filterApproversBySites(
                                          admins,
                                          siteAssociateArr.map(
                                            (siteAssociate) =>
                                              siteAssociate.site_id,
                                          ),
                                        )
                                          ?.slice()
                                          .sort((a, b) =>
                                            `${a.first_name} ${a.last_name}`.localeCompare(
                                              `${b.first_name} ${b.last_name}`,
                                            ),
                                          )
                                          .map((admin) => (
                                            <option
                                              key={admin.id}
                                              value={admin.id}
                                            >
                                              {admin.first_name}{' '}
                                              {admin.last_name}
                                            </option>
                                          ))}
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                      Please select an approver.
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </Col>
                              </Row>
                            ))}
                          </div>
                        ) : (
                          <div
                            className="text-center p-4"
                            style={{ marginTop: '20px' }}
                          >
                            No Records Found
                          </div>
                        )}
                      </Card.Body>
                    </Card>

                    <Card className="mb-4">
                      <CardHeader>
                        <strong>Rest Days</strong>
                      </CardHeader>
                      <CardBody>
                        <div className="mb-4 p-3 border rounded col-md-12">
                          <div className="row">
                            <div className="col-sm-12">
                              <table className="table table-bordered">
                                <thead>
                                  <tr>
                                    <th className="border-bottom-0">Day</th>
                                    <th className="border-bottom-0 text-center">
                                      Monday
                                    </th>
                                    <th className="border-bottom-0 text-center">
                                      Tuesday
                                    </th>
                                    <th className="border-bottom-0 text-center">
                                      Wednesday
                                    </th>
                                    <th className="border-bottom-0 text-center">
                                      Thursday
                                    </th>
                                    <th className="border-bottom-0 text-center">
                                      Friday
                                    </th>
                                    <th className="border-bottom-0 text-center">
                                      Saturday
                                    </th>
                                    <th className="border-bottom-0 text-center">
                                      Sunday
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td style={{ whiteSpace: 'nowrap' }}>
                                      <strong>Rest Days</strong>
                                    </td>
                                    <td className="text-center">
                                      <input
                                        type="checkbox"
                                        value="Mon"
                                        checked={restDays.includes('Mon')}
                                        onChange={(e) =>
                                          handleRestDayChange('Mon', e)
                                        }
                                        className="ms-1 form-check-input position-static"
                                      />
                                    </td>
                                    <td className="text-center">
                                      <input
                                        type="checkbox"
                                        value="Tue"
                                        checked={restDays.includes('Tue')}
                                        onChange={(e) =>
                                          handleRestDayChange('Tue', e)
                                        }
                                        className="ms-1 form-check-input position-static"
                                      />
                                    </td>
                                    <td className="text-center">
                                      <input
                                        type="checkbox"
                                        value="Wed"
                                        checked={restDays.includes('Wed')}
                                        onChange={(e) =>
                                          handleRestDayChange('Wed', e)
                                        }
                                        className="ms-1 form-check-input position-static"
                                      />
                                    </td>
                                    <td className="text-center">
                                      <input
                                        type="checkbox"
                                        value="Thu"
                                        checked={restDays.includes('Thu')}
                                        onChange={(e) =>
                                          handleRestDayChange('Thu', e)
                                        }
                                        className="ms-1 form-check-input position-static"
                                      />
                                    </td>
                                    <td className="text-center">
                                      <input
                                        type="checkbox"
                                        value="Fri"
                                        checked={restDays.includes('Fri')}
                                        onChange={(e) =>
                                          handleRestDayChange('Fri', e)
                                        }
                                        className="ms-1 form-check-input position-static"
                                      />
                                    </td>
                                    <td className="text-center">
                                      <input
                                        type="checkbox"
                                        value="Sat"
                                        checked={restDays.includes('Sat')}
                                        onChange={(e) =>
                                          handleRestDayChange('Sat', e)
                                        }
                                        className="ms-1 form-check-input position-static"
                                      />
                                    </td>
                                    <td className="text-center">
                                      <input
                                        type="checkbox"
                                        value="Sun"
                                        checked={restDays.includes('Sun')}
                                        onChange={(e) =>
                                          handleRestDayChange('Sun', e)
                                        }
                                        className="ms-1 form-check-input position-static"
                                      />
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </div>
                </div>
              )}
              <div
                className="border rounded d-flex"
                style={{
                  marginTop: '2rem',
                  marginLeft: '3rem',
                  marginRight: '3rem',
                  marginBottom: '1rem',
                }}
              >
                <div
                  style={{
                    minWidth: '15rem',
                    width: '15rem',
                    backgroundColor: '#f3f3f3',
                    padding: '2.25rem',
                  }}
                >
                  <strong>Additional Info</strong>
                  <p className="pt-2 text-muted">Manage additional details</p>
                </div>
                <div
                  className="flex-grow-1 bg-white"
                  style={{ padding: '2.25rem' }}
                >
                  <Row className="mb-3  pb-4">
                    <Form.Group as={Col} md="6">
                      <strong>Preferred Language</strong>
                      <Form.Control
                        as="select"
                        type="select"
                        name="language"
                        onChange={(e) => languageHandler(e)}
                        value={language ?? ''}
                      >
                        <option value="">Select Language</option>
                        <option value="en">English</option>
                        <option value="chi">Mandarin (普通)</option>
                      </Form.Control>
                    </Form.Group>
                  </Row>
                  <Row className="mb-3" style={{ justifyContent: 'flex-end' }}>
                    <button
                      type="button"
                      className="btn btn-success ms-3 adjust-fs adjust-shadow"
                      style={{ width: '9rem' }}
                      onClick={() => addMoreRoles()}
                    >
                      <i
                        className="fas fa-plus"
                        style={{
                          paddingRight: '0.5rem',
                        }}
                      ></i>
                      Add Roles
                    </button>
                  </Row>

                  {multipleRoles.length > 0 &&
                    multipleRoles.map(
                      (item, index) =>
                        !item.is_deleted && (
                          <Row className="mb-3" key={index}>
                            <Form.Group as={Col} md="6">
                              <strong>Position</strong>
                              <Form.Control
                                as="select"
                                type="select"
                                name="position"
                                onChange={(e) => positionHandler(e, index)}
                                value={item.role || ''}
                                disabled={item.associate_schedules.length > 0}
                              >
                                <option value="">Select Position</option>
                                {positionList &&
                                  positionList.map((positionItem) => (
                                    <option
                                      key={positionItem.value}
                                      value={positionItem.value}
                                    >
                                      {positionItem.label}
                                    </option>
                                  ))}
                              </Form.Control>
                            </Form.Group>
                            <Form.Group as={Col} md="4">
                              <strong>PB JO No.</strong>
                              <Form.Control
                                value={item.pb_jo_no || ''}
                                placeholder="PB Job Order No."
                                onChange={(e) =>
                                  positionPBJONOHandler(e, index)
                                }
                                maxLength={10}
                                disabled={item.associate_schedules.length > 0}
                              />
                            </Form.Group>

                            <Form.Group
                              as={Col}
                              md="2"
                              style={{
                                justifyContent: 'center',
                                alignSelf: 'center',
                              }}
                            >
                              {item.associate_schedules.length > 0 && (
                                <>
                                  <span style={{ fontSize: 12 }}>
                                    This is already being used in Smart
                                    Scheduler.
                                  </span>
                                  <br />
                                </>
                              )}

                              <span
                                className="text-danger"
                                style={{ cursor: 'pointer' }}
                                onClick={() => removeRoles(index)}
                              >
                                Remove
                              </span>
                            </Form.Group>
                          </Row>
                        ),
                    )}
                </div>
              </div>
              <div
                className="border rounded d-flex"
                style={{
                  marginTop: '2rem',
                  marginLeft: '3rem',
                  marginRight: '3rem',
                  marginBottom: [
                    ...oldSiteAssociates,
                    ...newSiteAssociates,
                  ].find((siteAssociate) => siteAssociate.is_team_support)
                    ? '6rem'
                    : '6rem',
                }}
              >
                <div
                  style={{
                    minWidth: '15rem',
                    width: '15rem',
                    backgroundColor: '#f3f3f3',
                    padding: '2.25rem',
                  }}
                >
                  <strong>Password</strong>
                  <p className="pt-2 text-muted">Reset Employee Password</p>
                </div>
                <div
                  className="flex-grow-1 bg-white"
                  style={{ padding: '2.25rem' }}
                >
                  <div className="row">
                    <div className="row pt-3">
                      <div className="col-sm-12">
                        <strong>New Password</strong>
                        <input
                          name="password"
                          type="text"
                          className="form-control mt-3"
                          value={password || ''}
                          onChange={(e) => passwordHandler(e)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                style={{
                  position: 'fixed',
                  bottom: 0,
                  width: activeSidebar ? 'calc(100vw - 310px)' : '100vw',
                  height: '4.5rem',
                  paddingLeft: '3rem',
                  paddingRight: '3rem',
                }}
                className="border-top bg-white d-flex justify-content-between align-items-center"
              >
                {associate.active ? (
                  <button
                    type="button"
                    onClick={() => deactivateAssociateHandler(associate.id)}
                    className="btn btn-outline-danger align-items-start adjust-fs adjust-shadow"
                    style={{ width: '12rem' }}
                  >
                    Deactivate Employee
                  </button>
                ) : (
                  <button
                    type="button"
                    onClick={() => activateAssociateHandler(associate.id)}
                    className="btn btn-outline-success align-items-start"
                    style={{ width: '12rem' }}
                  >
                    Activate Employee
                  </button>
                )}
                <div className="d-flex">
                  <button
                    type="button"
                    onClick={resendInvitesHandler}
                    disabled={isResendingInvites}
                    className="btn btn-outline-brand me-3 adjust-fs adjust-shadow"
                    style={{ width: '12rem' }}
                  >
                    {isResendingInvites ? 'Sending...' : 'Resend Invites'}
                  </button>
                  <button
                    type="button"
                    onClick={discardHandler}
                    className="btn btn-outline-brand adjust-fs adjust-shadow"
                    style={{ width: '12rem' }}
                  >
                    Discard
                  </button>
                  <button
                    type="submit"
                    className="btn btn-brand ms-3 adjust-fs adjust-shadow"
                    style={{ width: '12rem' }}
                  >
                    Save changes
                  </button>
                </div>
              </div>
            </Form>
          )}
          <Modal showModal={showLeaveSummaryModal}>
            <div className="h-100">
              <form
                className="d-flex flex-column justify-content-between flex-grow-1 h-100"
                onSubmit={handleLeaveSubmit} // Fixed: removed arrow function
              >
                {/* Header with X button */}
                <div className="mb-4 d-flex justify-content-between align-items-center">
                  <h5 className="mb-0 fw-semibold text-dark">
                    Manage Leave Credit
                  </h5>
                  <button
                    type="button"
                    onClick={handleCloseLeaveSummaryModal} // Fixed: removed arrow function
                    className="btn-close"
                    aria-label="Close"
                  ></button>
                </div>

                {/* Form Body */}
                <div className="flex-grow-1">
                  {/* Leave Type Selection */}
                  <div className="row mb-4 g-3">
                    <div className="col-4">
                      <label
                        htmlFor="leaveType"
                        className="form-label fw-medium mb-2"
                      >
                        Leave Type <span className="text-danger">*</span>
                      </label>
                      {modalMode === 'add' && (
                        <select
                          id="leaveType"
                          className="form-select adjust-fs"
                          value={leaveTypeId ?? ''}
                          onChange={(e) => setLeaveTypeId(e.target.value)}
                          required
                        >
                          <option value="">Select Leave Type</option>
                          {leaveTypes.map((leave) => (
                            <option key={leave.id} value={leave.id}>
                              {leave.name}
                            </option>
                          ))}
                        </select>
                      )}
                      {modalMode === 'edit' && (
                        <div className="mt-2">
                          <span className="form-control-plaintext fw-light">
                            {leaveTypeName}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Leave Allocation Section */}
                  <div className="mb-4">
                    <div className="row g-3">
                      <div className="col-4">
                        <label
                          htmlFor="maxPerYear"
                          className="form-label fw-medium mb-2"
                        >
                          Max Per Year
                        </label>
                        <input
                          type="number"
                          className="form-control adjust-fs"
                          id="maxPerYear"
                          value={maxLeaves}
                          onChange={(e) => setMaxLeaves(e.target.value)}
                          min="0"
                          step="0.5"
                          placeholder="0"
                        />
                      </div>
                      <div className="col-4">
                        <label
                          htmlFor="available"
                          className="form-label fw-medium mb-2"
                        >
                          Available
                        </label>
                        <input
                          type="number"
                          className="form-control adjust-fs"
                          id="available"
                          value={available}
                          onChange={(e) => setAvailable(e.target.value)}
                          min="0"
                          step="0.5"
                          placeholder="0"
                        />
                      </div>
                      {modalMode === 'edit' && (
                        <div className="col-4">
                          <label className="form-label fw-medium mb-2">
                            Taken
                          </label>
                          <div className="form-control-plaintext fw-light ms-2">
                            {taken || 0}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Active Period Section */}
                  <div className="mb-4">
                    <div className="row g-3">
                      <div className="col-4">
                        <label
                          htmlFor="activeFrom"
                          className="form-label fw-medium mb-2"
                        >
                          Active From <span className="text-danger">*</span>
                        </label>
                        <input
                          type="date"
                          id="activeFrom"
                          className="form-control adjust-fs"
                          value={activeDate}
                          onChange={(e) => setActiveDate(e.target.value)}
                          required
                        />
                      </div>
                      <div className="col-4">
                        <label
                          htmlFor="activeTo"
                          className="form-label fw-medium mb-2"
                        >
                          Active To <span className="text-danger">*</span>
                        </label>
                        <input
                          type="date"
                          id="activeTo"
                          className="form-control adjust-fs"
                          value={expiryDate}
                          onChange={(e) => setExpiryDate(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Footer Actions */}
                <div className="d-flex justify-content-end mt-auto pt-3 border-top">
                  <button
                    type="submit"
                    className="btn btn-brand adjust-fs adjust-shadow"
                    style={{ width: '12rem' }}
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </Modal>
        </div>
      )}
    </LayoutContext.Consumer>
  );
};

export default withRouter(EditAssociate);
